let DISABLE_DRAGGING = true;
import PropTypes from "prop-types";
import React from "react";
import {
  StyleSheet,
  View,
  UIManager,
  Platform,
  Animated,
  ActivityIndicator,
} from "react-native";
import ENV from "app/utils/ENV";
import haptics from "app/utils/haptics";
import Text from "app/components/Text";
import TouchableOpacity from "app/components/TouchableOpacity";
import apiActions from "app/utils/apiActions";
import chapterActions from "app/utils/chapterActions";
import momentActions from "app/utils/momentActions";
import valueActions from "app/utils/valueActions";
import prefActions from "app/utils/prefActions";
import noteActions from "app/utils/noteActions";
import alertActions from "app/utils/alertActions";
import toastActions from "app/utils/toastActions";
import chapterHelpers from "app/utils/chapterHelpers";
import textHelpers from "app/utils/textHelpers";
import timeHelpers from "app/utils/timeHelpers";
import momentHelpers from "app/utils/momentHelpers";
import colorHelpers from "app/utils/colorHelpers";
import valueHelpers from "app/utils/valueHelpers";
import frequencyHelpers from "app/utils/frequencyHelpers";
import * as RootNavigation from "app/utils/RootNavigation.js";
import {
  styleSheet,
  //   colors,
  //   sizes,
  //   screenRatio,
  mobileIncrease,
} from "app/utils/styleSheet";
import {
  FontAwesome,
  MaterialIcons,
  Feather,
  Ionicons,
  FontAwesome5,
  AntDesign,
  Entypo,
  SimpleLineIcons,
} from "@expo/vector-icons";
import store from "app/redux/store";

import Icon from "app/components/Icon";
import TextInput from "app/components/TextInput";
import Autocomplete from "app/components/Autocomplete";
import Target from "app/components/dragging/Target";
import HoverableTooltip from "app/components/HoverableTooltip";
import Hoverable from "app/components/Hoverable";

import DatePicker from "app/components/DatePicker";
import Badge from "app/components/chapter/Badge";
import ButtonBadge from "app/components/chapter/ButtonBadge";
import Value from "app/components/Value";
import MomentComposer from "app/components/chapter/MomentComposer";
import MomentForm from "app/components/chapter/MomentForm";
import Tag from "app/components/chapter/Tag";
import ValueListItem from "app/components/ValueListItem";
import ValueInspector from "app/components/ValueInspector";
import RecursiveMomentList from "app/components/chapter/RecursiveMomentList";
import EventEditor from "app/components/chapter/EventEditor";

import { StyleContext } from "app/contexts/Style";

const BULLETS = false;

export default class MomentBullet extends React.Component {
  static contextType = StyleContext;
  static propTypes = {
    backgroundColor: PropTypes.string,
    rightAlign: PropTypes.bool,
  };

  // Parents render bullets via inline .map() with closure props, so every
  // parent render used to re-render every bullet. Redux state is immutable
  // (reducers spread), so shallow comparison is sound for data props; function
  // props get fresh identities each render but stable behavior, so identity
  // churn alone must not force a re-render. Context updates bypass this
  // entirely, so style/theme changes still propagate.
  shouldComponentUpdate(nextProps, nextState) {
    if (this.state !== nextState) return true;
    let keys = Object.keys({ ...this.props, ...nextProps });
    for (let key of keys) {
      let a = this.props[key];
      let b = nextProps[key];
      if (a === b) continue;
      if (typeof a === "function" && typeof b === "function") continue;
      return true;
    }
    return false;
  }

  constructor(props) {
    super(props);

    let chapter = props.chapter;
    let rootChapter = props.rootChapter;
    let timestamp = undefined;
    if (
      !!chapter &&
      !chapter?.current &&
      !props.atemporal &&
      !props.parentIsValue
    ) {
      timestamp = timeHelpers.averageTimes([
        timeHelpers.dateToDateTime(chapter.start_at),
        timeHelpers.endOfDay(timeHelpers.dateToDateTime(chapter.end_at)),
      ]);
    } else if (
      props.pinnedMomentList &&
      !!rootChapter?.id &&
      !rootChapter?.current
    ) {
      timestamp = timeHelpers.averageTimes([
        timeHelpers.dateToDateTime(rootChapter.start_at),
        timeHelpers.endOfDay(timeHelpers.dateToDateTime(rootChapter.end_at)),
      ]);
    }

    let moment = props.moment;
    let value = moment?.value;
    this.state = {
      loading: false,
      fetching: false,
      expanded:
        props.expanded || //
        false,
      // (moment?.stance == "expanded" && !!chapter ? true : false),
      // initialStance: moment?.stance,
      // hidePinnedChildren: moment?.stance == "collapsed" ? true : false,
      hidePinnedChildren: false,
      focused: false,
      oneline: true,
      showInlineActions: false,
      parentQuery: "",
      childQuery: "",
      text: "",
      originalText: "",
      meta: false,
      shift: false,
      alt: false,
      timestamp,
      value: moment?.note || value,
      // momentType:
      //   value.is_progress || moment.progression ? "progress" : value.type,
      // isEditable: !!moment?.id && !moment?.completed_at && !value?.is_note,
      isEditable: !!value?.is_note,
      isEditable: true,
      firstParentSuggestion: null,
      firstChildSuggestion: null,
      showParents: false,
      lastUpdatedAt: null,
      editingText: false,
      scopedChildIds: [],
      scopingToChapter: props.expanded ? false : true,
      hasPinnedChildren: !!props.chapterMoments?.filter((moment) =>
        moment.value.parent_ids?.includes(value.id),
      ).length,
      showScheduler: false,
      moments: [],
      momentTimestamps: [],
    };
  }

  async componentDidMount() {
    let v = this.props.moment?.note || this.props.moment?.value;
    // console.log("mounting moment bullet: ", v?.text);
    if (this.props.expanded || this.props.moment?.stance == "expanded") {
      this.toggleExpanded(true, true);
    }
    this.subscribe();
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.expanded != prevProps.expanded) {
      // console.log("expanded changed", this.props.expanded);
      // if (!this.state.expandedIds.includes("root")) {
      //   this.toggleExpanded("root");
      // }
    }
    const momentChanged = (() => {
      try {
        return JSON.stringify(this.props.moment) !== JSON.stringify(prevProps.moment);
      } catch (e) {
        return this.props.moment !== prevProps.moment;
      }
    })();
    if (momentChanged) {
      let moment = this.props.moment;
      let value = moment?.value;
      let expanded = this.state.expanded;
      let initialStance = this.state.initialStance;
      if (this.state.initialStance != moment?.stance) {
        expanded = moment?.stance == "expanded" ? true : false;
        initialStance = moment?.stance;
      }
      this.setState({
        value: moment?.note || value,
        expanded,
        initialStance,
        // isEditable: !!moment?.id && !moment?.completed_at && !value?.is_note,
        // isEditable: !!value?.is_note,
      });
    }
    if (
      JSON.stringify(this.props.chapterMoments) !==
      JSON.stringify(prevProps.chapterMoments)
    ) {
      let value = this.props.moment?.value;
      if (!!value) {
        let hasPinnedChildren = !!this.props.chapterMoments?.filter((moment) =>
          moment.value.parent_ids?.includes(value.id),
        ).length;
        this.setState({ hasPinnedChildren });
      }
    }
  }

  componentWillUnmount() {
    // this.unsubscribeFocus && this.unsubscribeFocus();
    // this.unsubscribeBlur && this.unsubscribeBlur();
    this.unsubscribeRedux && this.unsubscribeRedux();
    // Flush any pending debounced text save so edits aren't lost when the
    // parent collapses and this component unmounts before the 1s timer fires.
    if (this.updateTimeout) {
      clearTimeout(this.updateTimeout);
      this.updateTimeout = null;
      this.updateValue();
    }
  }

  subscribe = async () => {
    // return;
    if (!!this.unsubscribeRedux) return;
    this.unsubscribeRedux = store.subscribe(() => {
      let { moments, values } = store.getState();
      // let moment = moments.find(c => c.id == this.props.moment.id)
      // if(!!moment){
      //   // this.updateMoment(moment)
      // }
      if (!!this.state.value?.id) {
        let value = values.find((v) => v.id == this.state.value?.id);
        if (!!value && !textHelpers.compareObjects(value, this.state.value)) {
          // console.log("updaing value bullet", value);
          this.setState({ value, loading: false });
          if (this.state.expandAfterLoading) {
            this.setState({ expandAfterLoading: false });
            this.toggleExpanded(true, true);
          }
        }
      }
    });
  };

  focus = () => {
    this.inputRef?.focus();
  };

  render() {
    let {
      moment,
      chapter,
      rightAlign,
      includeContext,
      includeAttribution,
      stackTags,
      horizontal,
      hideTags,
      hideText,
      pretext,
      wrapperStyle,
      chapterMoments,
      rootChapter,
      displayDraggableTarget,
      parentIsValue,
      parentId,
      shadeOnHover,
    } = this.props;
    let { value, showParents, isEditable } = this.state;
    let {
      expanded,
      editingText,
      text,
      focused,
      oneline,
      meta,
      alt,
      shift,
      isHovered,
    } = this.state;

    let valueColor = valueHelpers.getColor(value, this.context.colorScheme);

    return (
      <View
        style={[
          horizontal && { flexDirection: "row" },
          wrapperStyle,
          !ENV.WEB &&
            this.props.firstPinnedChild &&
            !expanded &&
            !focused && {
              marginTop: -(this.context.sizes.largeBulletWidth / 4),
            },
          { maxWidth: this.context.sizes.WIDTH },
          { flex: 1 },
        ]}
      >
        <View
          ref={(ref) => (this.ref = ref)}
          style={[horizontal && { justifyContent: "center" }]}
        >
          {!horizontal && showParents && this.renderParents()}

          {!hideTags &&
            (expanded || rightAlign) &&
            stackTags &&
            this.renderTags()}

          <Hoverable
            onHoverIn={() => this.setState({ isHovered: true })}
            onHoverOut={() =>
              this.setState({ isHovered: false, showButtonsRight: false })
            }
          >
            {(isHovered) => (
              <View
                style={[
                  {
                    flexDirection: "row",
                    alignItems: "center",
                    zIndex: 2,
                  },
                  rightAlign && { justifyContent: "flex-end" },
                ]}
              >
                {includeAttribution == "left" && this.renderAttribution()}

                {!rightAlign && this.renderBadge(true, isHovered)}

                {this.renderTextElem(isHovered)}

                {editingText && (
                  <Feather
                    name="x"
                    onPress={() => this.setState({ editingText: false })}
                    // color={valueColor}
                    color={this.context.colors.trim}
                    style={[
                      styleSheet.bullet,
                      styleSheet.mobileMediumBullet,
                      // { borderColor: valueColor },
                      { borderColor: this.context.colors.trim },
                      { zIndex: 3 },
                      { backgroundColor: this.context.colors.empty },
                    ]}
                  />
                )}
                {includeContext && this.renderContextString()}
                {rightAlign && this.renderBadge(false, isHovered, minHeight)}
                {includeAttribution == "right" && this.renderAttribution()}
                {this.renderButtons(isHovered)}
                {isHovered &&
                  !this.state.showButtonsRight &&
                  !this.state.badgeIsHovered &&
                  !this.state.buttonsIsHovered && (
                    <Hoverable
                      onHoverIn={() =>
                        this.setState({ showButtonsRight: true })
                      }
                    >
                      <View
                        style={{
                          position: "absolute",
                          right: this.context.sizes.small,
                        }}
                      >
                        <SimpleLineIcons
                          name="options"
                          color={valueColor}
                          style={[
                            styleSheet.bullet,
                            styleSheet.mobileMediumBullet,
                            { borderColor: valueColor },
                            { backgroundColor: this.context.colors.empty },
                          ]}
                        />
                      </View>
                    </Hoverable>
                  )}
                {!hideTags &&
                  !stackTags &&
                  ((horizontal && focused) ||
                    (!horizontal && (expanded || focused))) &&
                  this.renderTags()}
              </View>
            )}
          </Hoverable>
          {this.renderScheduler()}
          {this.renderParentInput()}
          {/*this.renderChildInput()*/}

          {!horizontal && (
            <View
              style={[
                showParents &&
                  {
                    // marginLeft: this.context.sizes.bulletWidth,
                  },
              ]}
            >
              {this.renderChildren()}
            </View>
          )}
        </View>

        {horizontal && this.renderChildren()}
      </View>
    );
  }

  renderTextElem = (isHovered) => {
    let {
      moment,
      pretext,
      chapter,
      rootChapter,
      multiline,
      rightAlign,
      style,
      expandedStyle,
      selectable,
      selectedIds,
      chapterMoments,
      showButtons,
      shadeOnHover,
      hideScrathpadPreview,
      pinnedMomentList,
      pinnedMomentParent,
      parentIsChild,
      parentIsValue,
    } = this.props;
    let { editingText, value, text, isEditable, parentQuery, showParents } =
      this.state;
    let { focused, expanded, oneline, showInlineActions } = this.state;

    // the text elem has a 120px min width, so in badge-only contexts (timeline
    // strips) it would overflow invisibly over neighbors and swallow clicks
    if (this.props.hideText && !expanded && !focused && !editingText)
      return null;

    let itemText = value?.title || value?.text || "";
    if (expanded) {
      itemText = value?.title || "";
    }
    if (!!pretext?.length) itemText = pretext + "\n" + itemText;

    // let filteredItemText =
    if (!focused) {
      itemText = valueHelpers.filterRichText(itemText, value, {
        removeLinebreaks: false,
      });
    }

    if (!focused && !expanded) {
      // itemText = itemText.split(`\n`)[0];
    }

    let placeholderText = itemText;
    if (!isEditable && ENV.WEB) {
      // if (!isEditable) {
      itemText = "";
    }

    let status = momentHelpers.getStatus(moment, rootChapter);

    let isCompletedNote =
      (value?.is_note || value?.category == "note") && !!value?.completed_at;
    let valueId = value?.id || moment.value_id;
    if (!!valueId && !!text?.length) {
      itemText = text;
    }

    let valueColor = valueHelpers.getColor(value, this.context.colorScheme);

    let textOpacity = !!chapter ? 0.3 : 1;
    textOpacity = 1;
    let textColor = this.context.colors.foreground;
    // let textColor = this.context.colors.trim;
    if (!!value?.color) {
      // textColor = valueColor
    }

    let pinnedChildrenMoments = (value?.child_ids || [])
      .map((cid) => {
        return chapterMoments?.find((cm) => cm.value?.id == cid);
      })
      .filter((x) => !!x);

    if (!!value?.archived_at) {
      textOpacity = 0.3;
    } else if (value?.category == "narration") {
      textColor = this.context.colors.trim;
      textOpacity = 1;
    } else if (!!value?.is_note || value?.category == "note") {
      // if (!!value?.color) {
      textColor = valueColor;
      // }
      if (isCompletedNote) {
        textOpacity = 0.3;
      } else {
        textOpacity = 0.6;
        // textColor = this.context.colors.foreground;
        // if (!!value?.color) {
        //   textOpacity = 0.4;
        //   textColor = colorHelpers.modifyHex(valueColor, 0.5);
        // }
      }
    } else if (
      !!value?.completed_at ||
      status == "note" ||
      status == "progressed_value" ||
      // (pinnedMomentList &&
      //   !!pinnedMomentParent &&
      //   momentHelpers.getStatus(pinnedMomentParent, rootChapter) ==
      //     "progressed_value") ||
      (!!pinnedChildrenMoments.length &&
        !pinnedChildrenMoments?.find((m) => !m.completed_at))
    ) {
      textOpacity = 1;
      // textOpacity = 0.6;
      textColor = this.context.colors.foreground;
      if (!!value?.color) {
        textColor = valueColor;
      }
    } else {
      // textOpacity = 0.6;
    }
    if (this.isPinnedNote()) {
      textColor = valueColor;
    }

    if (this.props.textColor) textColor = this.props.textColor;

    // console.log("val", value, textColor, itemText);
    if (selectable) {
      let selected = selectedIds.includes(value.id);
      if (!selected) textOpacity = 0.3;
    }
    if (this.props.textOpacity) textOpacity = this.props.textOpacity;

    let showFullText =
      multiline || (!oneline && (showInlineActions || expanded));

    // showFullText = true;

    if (!showFullText) {
      itemText = itemText.split(/[\r\n]/)[0];
    }

    if (!editingText && !focused) {
      if (!!moment?.title?.length) {
        // itemText = `${itemText} [${moment.title}]`;
        itemText = `${moment.title} [${itemText}]`;
        // itemText = `${moment.title} ∵(${itemText})`;
      }
    }

    let TextElem = ENV.WEB || editingText ? TextInput : Text;
    return (
      <View
        style={[
          { overflow: "visible" },
          { flex: 1, minWidth: 120, width: "auto" },
        ]}
      >
        <TouchableOpacity
          style={[
            { flex: 1 },
            { paddingHorizontal: this.context.sizes.small },
            !expanded &&
            this.props.pinnedMomentList &&
            this.state.hasPinnedChildren
              ? {
                  marginBottom:
                    (ENV.WEB
                      ? this.context.sizes.large
                      : this.context.sizes.largeBulletWidth) / 2,
                }
              : (!this.props.pinnedMomentList || expanded) && {
                  marginVertical:
                    (ENV.WEB
                      ? this.context.sizes.base
                      : this.context.sizes.largeBulletWidth) / 2,
                },
            shadeOnHover &&
              isHovered && {
                // !focused && {
                backgroundColor: this.context.colors.fill,
                borderRadius: this.context.sizes.smallBorderRadius,
              },
            // { alignItems: "flex-end" },
          ]}
          onLongPress={(e) => {
            if (ENV.WEB) {
              // RootNavigation.push("Project", { id: value.id }, e);
            } else {
              this.setState({ editingText: true }, () => {
                this.inputRef?.focus();
              });
            }
          }}
          // onPress={() => (ENV.WEB ? null : this.toggleInlineActions())}
          onPress={async (e) => {
            if (ENV.WEB) {
              if (e.button == 1) {
                RootNavigation.push("Project", { id: value.id }, e);
              }
            } else {
              // this.showActions();
              this.doublePressGraceTimeout = setTimeout(() => {
                if (this.actionIsVisible) return;
                this.setState({ showButtons: !showButtons });
                // haptics.light();
              }, this.context.DOUBLE_PRESS_THRESHOLD);
            }
          }}
          onDoublePress={(e) => {
            if (this.doublePressGraceTimeout)
              clearTimeout(this.doublePressGraceTimeout);
            if (!ENV.WEB) {
              // this.handleEnter();
              this.showActions();
              this.setState({ showButtons: false });
            }
          }}
        >
          <TextElem
            // inputRef={(c) => (this.inputRef = c)}
            inputRef={(ref) => {
              if (this.props.inputRef) {
                this.props.inputRef(ref);
              }
              return (this.inputRef = ref);
            }}
            defaultFocus={this.props.defaultFocus}
            placeholder={placeholderText || "Untitled"}
            placeholderTextColor={this.context.colors.trim}
            placeholderTextColor={textColor}
            // style
            numberOfLines={showFullText ? undefined : 1}
            multiline={showFullText}
            autoHeight={showFullText}
            // child-value bullets get two lines of title before truncating
            numberOfLines={
              expanded ? undefined : this.props.parentIsValue ? 2 : 1
            }
            // numberOfLines={undefined}
            // multiline={true}
            // autoHeight={true}
            // ellipsizeMode={!expanded ? 'tail' : undefined}
            ellipsizeMode={"tail"}
            // italic={value.isRevision}
            medium
            strike={
              !editingText &&
              !focused &&
              !expanded &&
              !isCompletedNote &&
              value?.category !== "narration" &&
              (isCompletedNote ||
                // status == "progressed_value" ||
                !!value?.completed_at ||
                !!moment.completed_at ||
                !!value?.archived_at)
              // !timeHelpers.wasToday(value?.completed_at)
            }
            // wrapperStyle={{
            //   borderWidth: 2,
            //   flex: -1,
            // }}
            style={[
              {
                color: textColor,
                opacity: textOpacity,
                flex: 1,
                // maxWidth: "90%",
                // maxWidth: this.props.pinnedMomentList ? "50%" : "90%",
                // minWidth: "50%",
                width: "100%",
              },
              rightAlign && {
                textAlign: "right",
              },
              // isCompletedNote && {
              //   textDecorationLine: "line-through",
              // },
              // !!moment.completed_at && !moment.note && {
              //   color:
              //     valueHelpers.colorAsHex(value?.color) || this.context.colors.foreground,
              //   fontWeight: 500,
              // },
              style,
              !oneline && (expanded || focused) && expandedStyle,
              this.isPinnedNote() && {
                fontSize: 12,
              },
              // START
              // { paddingHorizontal: this.context.sizes.small },
              // !expanded &&
              // this.props.pinnedMomentList &&
              // this.state.hasPinnedChildren
              //   ? {
              //       marginBottom:
              //         (ENV.WEB
              //           ? this.context.sizes.large
              //           : this.context.sizes.largeBulletWidth) / 2,
              //     }
              //   : (!this.props.pinnedMomentList || expanded) && {
              //       marginVertical:
              //         (ENV.WEB
              //           ? this.context.sizes.large
              //           : this.context.sizes.largeBulletWidth) / 2,
              //     },
              // shadeOnHover &&
              //   isHovered && {
              //     // !focused && {
              //     backgroundColor: this.context.colors.fill,
              //     borderRadius: this.context.sizes.smallBorderRadius,
              //   },
              // END
              // (true || !ENV.WEB) && {
              //   padding: this.context.sizes.small,
              //   paddingVertical: (ENV.WEB ? this.context.sizes.default : this.context.sizes.largeBulletWidth) / 2,
              //   // if a list has pinnedMomentList bullets present and they _dont_ get the paddingVertical, the vertical scrollview stops working...??
              // },
              // stamp aesthetic
              // (parentIsValue || parentIsChild) &&
              false &&
                !!value.child_ids.length && {
                  color: valueColor,
                  backgroundColor: colorHelpers.hexToRgbaString(
                    valueColor,
                    0.3,
                  ),
                  borderRadius: this.context.sizes.smallBorderRadius,
                },
              editingText && {
                // borderBottomWidth: 1,
                // borderColor: this.context.colors.trim,
                // borderColor: valueColor,
                backgroundColor: this.context.colors.fill,
              },
            ]}
            // input listeners
            // onShiftEnter={this.handleToggleNote}
            // onShiftEnter={this.handlEnter}
            onShiftEnter={this.handlCycleCategory}
            onMetaEnter={this.handleMetaEnter}
            onAltEnter={this.handleAltEnter}
            // onEnter={!value?.is_note ? this.handleEnter : undefined}
            captureEnterOnlyWithItem
            onEnter={this.handleEnter}
            onDelete={({ shiftKey } = {}) => shiftKey ? this.handleSnoozeForWeek() : this.handleDeleteMoment(true)}
            onChangeText={(text) => {
              // if(!!item.value_id){
              if (!text?.length) {
                this.setState({
                  text: "",
                  parentQuery: "",
                  noChldSuggestion: null,
                  firstChildSuggestion: null,
                  firstParentSuggestion: null,
                });
              } else if (text?.includes("#")) {
                let parentQuery = text.split("#")[1];
                this.setState({ text, parentQuery });
              } else {
                this.handleChangeText(text);
              }
              this.setState({ text });
              // }
            }}
            onSetMeta={(meta) => this.setState({ meta })}
            onSetShift={(shift) => this.setState({ shift })}
            onSetAlt={(alt) => this.setState({ alt })}
            onFocus={() => {
              this.setState({ focused: true, oneline: false });
              this.props.onFocus && this.props.onFocus();
            }}
            onBlur={async () => {
              // Flush any pending debounced save immediately on blur so the
              // save is in-flight before the parent might collapse/re-expand.
              if (this.updateTimeout) {
                clearTimeout(this.updateTimeout);
                this.updateTimeout = null;
                this.updateValue();
              }
              await new Promise((r) => setTimeout(r, 0));
              this.setState({
                focused: false,
                shift: false,
                meta: false,
                oneline: this.props.expanded,
              });
            }}
            onMetaDown={async () => {
              // if (!!chapter)
              //   momentActions.update(moment.id, { stance: "expanded" });
              await this.toggleExpanded(true);
            }}
            onMetaUp={async () => {
              if (expanded) {
                // if (!!chapter)
                //   momentActions.update(moment.id, {
                //     stance: "collapsed",
                //   });
                await this.toggleExpanded(false);
              } else {
                // !!this.props.onFocusChapterTitle &&
                //   this.props.onFocusChapterTitle();
                if (
                  this.state.hasPinnedChildren &&
                  !this.state.hidePinnedChildren
                ) {
                  // if (!!chapter)
                  //   momentActions.update(moment.id, {
                  //     stance: "collapsed",
                  //   });
                  this.toggleExpanded(false);
                } else {
                  this.toggleParents();
                }
              }
            }}
            onMetaCtrlRight={() =>
              RootNavigation.push("Project", { id: value.id })
            }
            onMetaCtrlShiftRight={() =>
              RootNavigation.push("Project", { id: value.id }, { newTab: true })
            }
            onMetaShiftArrow={async (direction) => {
              // NB: "up" deliberately unbound — ⌘⇧↑ is select-to-start
              // muscle memory in text fields, and this used to silently pin
              // the value to the parent (week/month) chapter by accident
              if (direction == "right") {
                // Pin the value to the next chapter (reused if it exists,
                // created if not) without navigating away from the current
                // chapter. The backend handles find-or-create + pinning.
                await momentActions.copyToNextChapter(moment.id);
              }
            }}
            // focusPrevious={() => this.focusPrevious(value.id, values, i, parent)}
            // focusNext={() => this.focusNext(value.id, expanded, values, i, children, uncles, parentIndex)}
            // focusPreviousJump={() => this.focusPreviousJump(value.id, values, i, parent)}
            // focusNextJump={() => this.focusNextJump(value.id, expanded, values, i, children)}
            // editable={false}
            onAltUp={() => {
              // Move focus to the chapter header; a second alt+up from the title will collapse.
              this.props.onFocusChapterTitle
                ? this.props.onFocusChapterTitle()
                : this.props.onCollapseChapter && this.props.onCollapseChapter();
            }}
            onAltDown={() => {
              if (this.props.chapterExpanded) {
                this.props.focusParentComposer &&
                  this.props.focusParentComposer();
              } else {
                this.props.onExpandChapter && this.props.onExpandChapter();
              }
            }}
            // onAltLeft={() => {
            //   this.props.onFocusPreviousChapter &&
            //     this.props.onFocusPreviousChapter();
            // }}
            // onAltRight={() => {
            //   this.props.onFocusNextChapter && this.props.onFocusNextChapter();
            // }}
            ctrlAltUp={async () => {
              if (!this.props.onPinToParentChapter) return;
              // easy to hit by accident, and the result (a pin on the
              // week/month chapter) is invisible from here — confirm first
              let conf = await alertActions.confirm(
                "Pin this item to the parent chapter?",
              );
              if (conf) this.props.onPinToParentChapter(value);
            }}
            // onMetaCtrlShiftUp={() => {
            //   this.props.onPinToParentChapter &&
            //     this.props.onPinToParentChapter(value);
            // }}
            metaCtrlUp={() => {
              this.props.sortItemUp && this.props.sortItemUp();
            }}
            metaCtrlDown={() => {
              this.props.sortItemDown && this.props.sortItemDown();
            }}
            onMetaCtrlShiftUp={() => {
              this.props.sortItemToTop && this.props.sortItemToTop();
            }}
            onMetaCtrlShiftDown={() => {
              this.props.sortItemToBottom && this.props.sortItemToBottom();
            }}
            onMetaAltShiftArrow={async (direction) => {
              if (direction == "up") {
                this.props.sortItemToTop && this.props.sortItemToTop();
              } else if (direction == "down") {
                this.props.sortItemToBottom && this.props.sortItemToBottom();
              }
            }}
            onMetaD={async () => {
              let res = await valueActions.duplicate(value, rootChapter.id);
              this.props.onRefreshChapter && this.props.onRefreshChapter();
            }}
            onNatUp={(e) => {
              if (!!this.searchRef) {
                this.searchRef.handleKeyPress(e);
                return;
              }
              if (showParents) {
                if (this.parentListRef?.handleFocusComposer) {
                  this.parentListRef?.handleFocusComposer();
                }
              } else {
                this.props.focusPrevious && this.props.focusPrevious();
              }
            }}
            onNatDown={(e) => {
              if (!!this.searchRef) {
                this.searchRef.handleKeyPress(e);
                return;
              }
              if (this.state.expanded) {
                this.handleFocusFirstChild();
                return;
              }
              if (!!parentQuery?.length) {
                this.searchRef && this.searchRef.nextSuggestion();
                return;
              }
              this.props.focusNext && this.props.focusNext();
            }}
            onEscape={() => {
              this.setState({
                firstChildSuggestion: null,
                noChldSuggestion: true,
              });
              this.props.onEscape && this.props.onEscape();
              if (this.state.showParents) this.toggleParents();
              // browsing from a composer's suggestion list: escape anywhere
              // in the tree collapses the expansion and refocuses the root
              this.props.onBrowseEscape && this.props.onBrowseEscape();
            }}
            // onLongPress={async (e) => {
            //   if (ENV.WEB) {
            //     RootNavigation.push("Project", { id: value.id }, e);
            //   } else {
            //     await this.setState({ editingText: true });
            //     this.inputRef?.focus();
            //   }
            // }}
            // // onPress={() => (ENV.WEB ? null : this.toggleInlineActions())}
            // onPress={(e) => {
            //   if (ENV.WEB) {
            //     if (e.button == 1) {
            //       RootNavigation.push("Project", { id: value.id }, e);
            //     }
            //   } else {
            //     // this.showActions();
            //     this.setState({ showButtons: !showButtons });
            //     // haptics.light();
            //   }
            // }}
            // onDoublePress={(e) => {
            //   alert("double press!");
            //   // if(!ENV.WEB){
            //   //   this.handleEnter()
            //   // }
            // }}
          >
            {itemText}
          </TextElem>
        </TouchableOpacity>
        {this.renderProgressBar()}
      </View>
    );
  };

  renderBadge = (leftAlign = true, isHovered = false) => {
    let {
      moment,
      chapter,
      rootChapter,
      valueBadge,
      rightAlign,
      hideText,
      selectable,
      selectedIds,
      hideTags,
    } = this.props;
    let { value, showParents, loading } = this.state;
    let { expanded, editing, editingText, text, focused, meta, shift } =
      this.state;

    let minHeight =
      this.context.sizes.default * this.context.sizes.lineHeightRatio - 8;
    if (!this.props.pinnedMomentList || expanded) {
      minHeight += ENV.WEB
        ? this.context.sizes.large
        : this.context.sizes.largeBulletWidth;
    }

    let childIndicator = null;
    let backgroundColor = valueHelpers.getColor(
      value,
      this.context.colorScheme,
      this.context.colors.foreground,
    );
    // let hideChildIndicator = hideText && !expanded; // || value?.is_note;
    let hideChildIndicator = hideText || expanded;
    if (!!value?.child_ids?.length && !hideChildIndicator) {
      // childIndicator = (
      //   <View style={[this.styles().childIndicatorFill, { backgroundColor }]} />
      // );
      // childIndicator = (
      //   <View
      //     style={[
      //       this.styles().childIndicator,
      //       this.styles().smallChildIndicator,
      //       { backgroundColor },
      //     ]}
      //   />
      // );
      if (!BULLETS) {
        childIndicator = (
          <View
            style={[
              this.styles().childIndicatorCaret,
              // { top: minHeight / 2 }
            ]}
          >
            <FontAwesome5
              size={12}
              name={false ? "caret-down" : "caret-right"}
              style={[
                this.state.hidePinnedChildren && {
                  transform: [{ rotateZ: "-90deg" }],
                },
              ]}
              color={backgroundColor}
            />
          </View>
        );
      }
    }
    let noteIndicator = null;
    if (
      (!!value.text?.length && value.text != value.title) ||
      value.title?.split(/[\r\n]/).length > 1 ||
      moment?.text?.length > 1
    ) {
      noteIndicator = (
        <View
          style={[
            // this.styles().noteIndicator,
            this.styles().noteIndicatorLine,
            // { top: minHeight / 2 },
            // !childIndicator && { left: this.context.sizes.tiny },
            { backgroundColor },
          ]}
        />
      );
    }
    let badge = null;
    if (selectable) {
      let selected = selectedIds.includes(value.id);
      // badge = (
      //   <TouchableOpacity onPress={() => this.props.onSelectValue(value.id)}>
      //     <View
      //       style={[
      //         styleSheet.bullet,
      // styleSheet.mobileMediumBullet,
      //         styleSheet.largeBullet,
      //         {
      //           borderColor: selected ? backgroundColor : this.context.colors.trim,
      //         },
      //       ]}
      //     >
      //       {selected && (
      //         <Ionicons
      //           name={"md-checkmark"}
      //           size={this.context.sizes.default}
      //           color={backgroundColor}
      //         />
      //       )}
      //     </View>
      //   </TouchableOpacity>
      // );
      badge = (
        <Badge
          bulletOnly={!this.props.showIcon && BULLETS}
          chapter={rootChapter}
          tooltipOptions={this.props.tooltipOptions}
          noTooltip
          checkIcon
          iconColor={selected ? backgroundColor : this.context.colors.trim}
          ringColor={
            value.is_note
              ? null
              : selected
                ? backgroundColor
                : this.context.colors.trim
          }
          backgroundColor={this.context.colors.empty}
          moment={moment}
          onPress={() => this.props.onSelectValue(value.id)}
          large={this.props.largeBullet}
          scale={this.props.badgeScale}
          mobileLarge={this.props.smallBadge ? false : true}
          loading={loading}
        />
      );
    } else if (valueBadge) {
      let backgroundColor = undefined;
      let style = undefined;
      if (value.is_note) backgroundColor = this.context.colors.empty;
      if (!value.completed_at && !value.has_children) {
        backgroundColor = this.context.colors.empty;
        style = {
          borderWidth: 2,
          borderColor: valueHelpers.getColor(value),
          opacity: 0.8,
        };
      }
      badge = (
        <Value
          value={value}
          onPress={this.handleBadgePress}
          noText
          size={50}
          style={style}
          backgroundColor={backgroundColor}
        />
      );
    } else {
      badge = (
        <Badge
          // highlighted={!!noteIndicator}
          bulletOnly={!this.props.showIcon && BULLETS}
          // let complete = !!this.props.moments?.find((m) => m.node_id == item.id)
          // ?.completed_at;
          // value={value}
          // moment={this.props.moments?.find((m) => m.value_id == value.id)}
          tooltipOptions={this.props.tooltipOptions}
          chapter={rootChapter}
          noTooltip={!!this.props.tooltipText?.length ? false : true}
          // noTooltip={hideTags}
          // noTooltip={
          //   value.is_note
          //     ? false
          //     : this.props.showTooltip && !expanded
          //     ? false
          //     : true
          // }
          tooltipText={
            this.props.tooltipText || textHelpers.fullDateTime(value.created_at)
          }
          invertNote={shift}
          invertCompleted={meta}
          // moment={moment}
          moment={{ ...moment, value }}
          onPress={this.handleBadgePress}
          showActionsOnHover={this.props.noActions ? false : true}
          bulletIsHovered={isHovered}
          onShowActions={() => this.showActions()}
          expanded={expanded}
          large={this.props.largeBullet}
          noteIcon={this.props.noteIcon}
          noIcon={this.props.noIcon}
          scale={
            this.props.badgeScale ||
            (ENV.WEB && this.props.pinnedMomentList && !expanded && !focused)
              ? 0.7
              : undefined
          }
          mobileLarge={
            this.props.smallBadge
              ? false
              : this.props.pinnedMomentList && !expanded && !focused
                ? false
                : true
          }
          onDragStart={() => this.props.onStartDraggingBadge(moment.id)}
          onDragEnd={this.props.onEndDraggingBadge}
          style={this.props.badgeStyle}
          loading={loading}
          // onHoverIn={() => !hideTags && this.setState({ badgeIsHovered: true })}
          onHoverOut={() =>
            !hideTags && this.setState({ badgeIsHovered: false })
          }
          // hoverDelay={1200}
          onHoverInOptions={() =>
            !hideTags && this.setState({ badgeIsHovered: true })
          }
          // onHoverOutOptions={() =>
          //   !hideTags && this.setState({ badgeIsHovered: false })
          // }
          onRightClick={() => {
            !hideTags &&
              this.setState({ badgeIsHovered: !this.state.badgeIsHovered });
          }}
        />
      );
    }

    // minHeight = this.context.sizes.default * this.context.sizes.lineHeightRatio;
    // textelem height
    minHeight = 5;

    // let additionalBadges = (
    //   this.props.chapterMoments?.filter(
    //     (m) => m.value_ids?.includes(moment.value_id) && m.id != moment.id,
    //   ) || []
    // ).map((m) => (
    //   <Badge
    //     bulletOnly={!this.props.showIcon && BULLETS}
    //     chapter={rootChapter}
    //     moment={{ ...m, value }}
    //     onPress={this.handleBadgePress}
    //     large={this.props.largeBullet}
    //     style={this.props.badgeStyle}
    //   />
    // ));

    return (
      <View
        style={[
          { zIndex: 2 },
          // !ENV.WEB && { padding: this.context.sizes.small },
          { alignSelf: "flex-start" },
          { alignSelf: "center" },
          { minHeight, justifyContent: "center" },
        ]}
      >
        {leftAlign && childIndicator}
        {leftAlign && noteIndicator}
        <View style={{ flexDirection: "row" }}>
          {badge}
          {/*{additionalBadges}*/}
        </View>
        {!leftAlign && childIndicator}
        {!leftAlign && noteIndicator}
      </View>
    );
  };

  renderButtons = (isHovered) => {
    let { showButtons, badgeIsHovered, buttonsIsHovered, showButtonsRight } =
      this.state;
    isHovered = badgeIsHovered || buttonsIsHovered || showButtonsRight;
    let rightAligned = showButtonsRight || !ENV.WEB;
    let {
      moment,
      chapter,
      rightAlign,
      stackTags,
      hideText,
      pretext,
      chapterMoments,
      rootChapter,
    } = this.props;
    if (!!moment.category) return;
    let { value, expanded, focused, showScheduler, showDirections } =
      this.state;
    // let valueColor = !!value?.color?.length
    //   ? valueHelpers.colorAsHex(value.color, this.context.colorScheme)
    //   : this.context.colors.trim;
    let valueColor = valueHelpers.getColor(value, this.context.colorScheme);

    if (hideText && !expanded) return null;
    if (ENV.WEB && !isHovered) return null;
    if (!ENV.WEB && !showButtons) return null;

    //if(!hideText || expanded) &&
    //(isHovered || (!ENV.WEB && expanded)) && (

    let isPinned =
      !!rootChapter?.id &&
      !!chapterMoments?.find((m) => m.value?.id == value.id);

    let focusIds = store.getState().preferences.focusIds;
    let isFocused = focusIds.includes(value.id);

    let ShelfWrapper = ENV.WEB ? View : TouchableOpacity;

    if (showDirections) {
      return (
        <Hoverable
          onHoverIn={() => this.setState({ buttonsIsHovered: true })}
          onHoverOut={() =>
            this.setState({
              buttonsIsHovered: false,
              showButtonsRight: false,
              showDirections: false,
              showButtons: false,
              badgeIsHovered: false,
            })
          }
        >
          <ShelfWrapper
            onPress={() => {
              this.setState({ showButtons: false });
              haptics.light();
            }}
            style={[
              this.styles().tagWrapper,
              rightAligned && this.styles().rightAlignedTagWrapper,
              { backgroundColor_xxx: "transparent" },
            ]}
          >
            <HoverableTooltip text={"Parent Chapter"}>
              <TouchableOpacity
                haptics={"warn"}
                onPress={async (e) => {
                  let move = this.isMoveClick(e);
                  this.setState({
                    showDirections: false,
                    showButtons: false,
                    badgeIsHovered: false,
                  });
                  haptics.light();
                  await this.props.onPinToParentChapter(value);
                  if (move) await this.removeCurrentPin();
                }}
              >
                <FontAwesome5
                  name={"angle-double-up"}
                  color={valueColor}
                  style={[
                    styleSheet.bullet,
                    styleSheet.mobileMediumBullet,
                    { borderColor: valueColor },
                    {
                      backgroundColor: this.context.colors.empty,
                    },
                  ]}
                />
              </TouchableOpacity>
            </HoverableTooltip>
            <HoverableTooltip text={"Sub-Chapter"}>
              <TouchableOpacity haptics={"warn"} onPress={() => null}>
                <FontAwesome5
                  name={"angle-double-down"}
                  color={valueColor}
                  style={[
                    styleSheet.bullet,
                    styleSheet.mobileMediumBullet,
                    { borderColor: valueColor },
                    {
                      backgroundColor: this.context.colors.empty,
                    },
                  ]}
                />
              </TouchableOpacity>
            </HoverableTooltip>
            <HoverableTooltip text={"Next Chapter"}>
              <TouchableOpacity
                haptics={"warn"}
                onPress={async (e) => {
                  let move = this.isMoveClick(e);
                  this.setState({
                    showDirections: false,
                    showButtons: false,
                    badgeIsHovered: false,
                  });
                  // Pin to the next chapter without swapping the current view.
                  await momentActions.copyToNextChapter(moment.id);
                  if (move) await this.removeCurrentPin();
                }}
              >
                <FontAwesome5
                  name={"angle-double-right"}
                  color={valueColor}
                  style={[
                    styleSheet.bullet,
                    styleSheet.mobileMediumBullet,
                    { borderColor: valueColor },
                    {
                      backgroundColor: this.context.colors.empty,
                    },
                  ]}
                />
              </TouchableOpacity>
            </HoverableTooltip>
            <HoverableTooltip text={"Sort Up"}>
              <TouchableOpacity
                haptics={"warn"}
                onPress={async () => {
                  this.setState({
                    showDirections: false,
                    showButtons: false,
                    badgeIsHovered: false,
                  });
                  this.props.sortItemUp();
                }}
              >
                <FontAwesome5
                  name={"chevron-up"}
                  color={valueColor}
                  style={[
                    styleSheet.bullet,
                    styleSheet.mobileMediumBullet,
                    { borderColor: valueColor },
                    {
                      backgroundColor: this.context.colors.empty,
                    },
                  ]}
                />
              </TouchableOpacity>
            </HoverableTooltip>
            <HoverableTooltip text={"Sort Down"}>
              <TouchableOpacity
                haptics={"warn"}
                onPress={async () => {
                  this.setState({
                    showDirections: false,
                    showButtons: false,
                    badgeIsHovered: false,
                  });
                  this.props.sortItemDown();
                }}
              >
                <FontAwesome5
                  name={"chevron-down"}
                  color={valueColor}
                  style={[
                    styleSheet.bullet,
                    styleSheet.mobileMediumBullet,
                    { borderColor: valueColor },
                    {
                      backgroundColor: this.context.colors.empty,
                    },
                  ]}
                />
              </TouchableOpacity>
            </HoverableTooltip>

            {!ENV.WEB && (
              <HoverableTooltip text="Close">
                <TouchableOpacity
                  haptics
                  onPress={(e) => {
                    this.setState({
                      showButtons: false,
                      showDirections: false,
                      badgeIsHovered: false,
                    });
                    this.props.onEscape && this.props.onEscape();
                  }}
                >
                  <Feather
                    name="x"
                    color={valueColor}
                    style={[
                      styleSheet.bullet,
                      styleSheet.mobileMediumBullet,
                      { borderColor: valueColor },
                      { backgroundColor: this.context.colors.empty },
                    ]}
                  />
                </TouchableOpacity>
              </HoverableTooltip>
            )}
          </ShelfWrapper>
        </Hoverable>
      );
    }

    return (
      <Hoverable
        onHoverIn={() => {
          this.setState({ buttonsIsHovered: true });
        }}
        onHoverOut={() => {
          this.setState({
            buttonsIsHovered: false,
            showButtonsRight: false,
            showDirections: false,
            showButtons: false,
            badgeIsHovered: false,
          });
        }}
      >
        <ShelfWrapper
          onPress={() => {
            this.setState({ showButtons: false });
            haptics.light();
          }}
          style={[
            this.styles().tagWrapper,
            rightAligned && this.styles().rightAlignedTagWrapper,
            { backgroundColor_xxx: "transparent" },
          ]}
        >
          {!!rootChapter && !rootChapter?.is_vlaue && (
            <HoverableTooltip text={"Move"}>
              <TouchableOpacity
                haptics
                onPress={() => this.setState({ showDirections: true })}
              >
                <Feather
                  name={"move"}
                  color={valueColor}
                  style={[
                    styleSheet.bullet,
                    styleSheet.mobileMediumBullet,
                    { borderColor: valueColor },
                    {
                      backgroundColor: this.context.colors.empty,
                    },
                  ]}
                />
              </TouchableOpacity>
            </HoverableTooltip>
          )}
          {/*<HoverableTooltip text={value.is_note ? "Make Value" : "Make Note"}>
            <TouchableOpacity
              haptics
              onPress={() => {
                this.setState({ showButtons: false, badgeIsHovered: false });
                this.handleToggleNote();
              }}
            >
              <FontAwesome
                name="file-text-o"
                color={value.is_note ? this.context.colors.empty : valueColor}
                style={[
                  styleSheet.bullet,
                  styleSheet.mobileMediumBullet,
                  { borderColor: valueColor },
                  {
                    backgroundColor: value.is_note
                      ? valueColor
                      : this.context.colors.empty,
                  },
                ]}
              />
            </TouchableOpacity>
          </HoverableTooltip>*/}
          <HoverableTooltip text={"Schedule"}>
            <TouchableOpacity
              haptics //={"warn"}
              onPress={this.toggleShowScheduler}
            >
              <Entypo
                name={"calendar"}
                color={showScheduler ? this.context.colors.empty : valueColor}
                style={[
                  styleSheet.bullet,
                  styleSheet.mobileMediumBullet,
                  { borderColor: valueColor },
                  {
                    backgroundColor: showScheduler
                      ? valueColor
                      : this.context.colors.empty,
                  },
                ]}
              />
            </TouchableOpacity>
          </HoverableTooltip>

          <HoverableTooltip
            text={isFocused ? "Remove from focus" : "Add to focus"}
          >
            <TouchableOpacity
              haptics={"warn"}
              onPress={async () => {
                this.setState({ showButtons: false, badgeIsHovered: false });
                if (isFocused) {
                  let res = await prefActions.removeFocus(value.id);
                } else {
                  let res = await prefActions.addFocus(value.id);
                  // console.log("res!!!", res);
                  // if (res?.chapter && this.props.onUpdateChapter) {
                  //   this.props.onUpdateChapter(res.chapter);
                  // }
                }
              }}
            >
              <SimpleLineIcons
                name={"target"}
                color={isFocused ? this.context.colors.empty : valueColor}
                style={[
                  styleSheet.bullet,
                  styleSheet.mobileMediumBullet,
                  { borderColor: valueColor },
                  {
                    backgroundColor: isFocused
                      ? valueColor
                      : this.context.colors.empty,
                  },
                ]}
              />
            </TouchableOpacity>
          </HoverableTooltip>

          {!!rootChapter && !rootChapter?.is_value ? (
            <HoverableTooltip
              text={isPinned ? "Remove from chapter" : "Pin item to chapter"}
            >
              <TouchableOpacity
                // haptics={isPinned ? "light" : "medium"}
                haptics={"warn"}
                onPress={async () => {
                  this.setState({ showButtons: false, badgeIsHovered: false });
                  if (isPinned) this.handleDeleteMoment(false);
                  else {
                    let res = await chapterActions.pinValue(
                      rootChapter.id,
                      value.id,
                    );
                    if (res?.chapter && this.props.onUpdateChapter) {
                      this.props.onUpdateChapter(res.chapter);
                    }
                  }
                }}
              >
                <MaterialIcons
                  name={"push-pin"}
                  color={isPinned ? this.context.colors.empty : valueColor}
                  style={[
                    styleSheet.bullet,
                    styleSheet.mobileMediumBullet,
                    { borderColor: valueColor },
                    {
                      backgroundColor: isPinned
                        ? valueColor
                        : this.context.colors.empty,
                    },
                  ]}
                />
              </TouchableOpacity>
            </HoverableTooltip>
          ) : rootChapter?.is_value && !!value.parent_ids?.length ? (
            <HoverableTooltip text={"Remove child"}>
              <TouchableOpacity
                haptics={"light"}
                onPress={() => {
                  this.handleDeleteMoment(true);
                  this.setState({ showButtons: false, badgeIsHovered: false });
                }}
              >
                <FontAwesome
                  name={"unlink"}
                  color={valueColor}
                  style={[
                    styleSheet.bullet,
                    styleSheet.mobileMediumBullet,
                    { borderColor: valueColor },
                    { backgroundColor: this.context.colors.empty },
                  ]}
                />
              </TouchableOpacity>
            </HoverableTooltip>
          ) : null}

          <HoverableTooltip
            text={
              !!moment.value?.is_note
                ? !!moment.value.completed_at
                  ? "Uncomplete note"
                  : "Complete note"
                : !!moment.value?.completed_at
                  ? "Uncomplete item"
                  : valueHelpers.getRipe(value)
                    ? "Complete item"
                    : !!moment.completed_at
                      ? "Undo progress"
                      : `Log progress`
            }
          >
            <TouchableOpacity
              haptics={false}
              onPress={this.handleEnter}
              onLongPress={this.handleMetaEnter}
            >
              <Entypo
                name={"check"}
                color={
                  !!moment.completed_at || !!moment.value?.completed_at
                    ? this.context.colors.empty
                    : valueColor
                }
                style={[
                  styleSheet.bullet,
                  styleSheet.mobileMediumBullet,
                  { borderColor: valueColor },
                  {
                    backgroundColor:
                      !!moment.completed_at || !!moment.value?.completed_at
                        ? valueColor
                        : this.context.colors.empty,
                  },
                ]}
              />
            </TouchableOpacity>
          </HoverableTooltip>

          <HoverableTooltip text="Go to item">
            <TouchableOpacity
              haptics
              onPress={(e) => {
                this.setState({ showButtons: false, badgeIsHovered: false });
                RootNavigation.push("Project", { id: value.id }, e);
              }}
            >
              <Entypo
                name="chevron-right"
                color={valueColor}
                style={[
                  styleSheet.bullet,
                  styleSheet.mobileMediumBullet,
                  { borderColor: valueColor },
                  { backgroundColor: this.context.colors.empty },
                ]}
              />
            </TouchableOpacity>
          </HoverableTooltip>

          {this.props.asyncMoment && (
            <HoverableTooltip text="Go to chapter">
              <TouchableOpacity
                haptics
                onPress={(e) => {
                  this.setState({ showButtons: false, badgeIsHovered: false });
                  let timestamp = moment.completed_at || moment.created_at;
                  let date = timeHelpers.dateTimeToDate(timestamp);
                  RootNavigation.push("Chapters", { date }, e);
                }}
              >
                <Entypo
                  name="chevron-right"
                  color={valueColor}
                  style={[
                    styleSheet.bullet,
                    styleSheet.mobileMediumBullet,
                    { borderColor: valueColor },
                    { backgroundColor: this.context.colors.empty },
                  ]}
                />
              </TouchableOpacity>
            </HoverableTooltip>
          )}

          {!!this.props.bonusButtonText && (
            <HoverableTooltip text={this.props.bonusButtonText}>
              <TouchableOpacity
                haptics
                onPress={(e) => {
                  this.props.bonusButtonAction();
                }}
              >
                <Entypo
                  name="plus"
                  color={valueColor}
                  style={[
                    styleSheet.bullet,
                    styleSheet.mobileMediumBullet,
                    { borderColor: valueColor },
                    { backgroundColor: this.context.colors.empty },
                  ]}
                />
              </TouchableOpacity>
            </HoverableTooltip>
          )}

          {!ENV.WEB && (
            <HoverableTooltip text="Close">
              <TouchableOpacity
                haptics
                onPress={(e) => {
                  this.setState({ showButtons: false, badgeIsHovered: false });
                  this.props.onEscape && this.props.onEscape();
                }}
              >
                <Feather
                  name="x"
                  color={valueColor}
                  style={[
                    styleSheet.bullet,
                    styleSheet.mobileMediumBullet,
                    { borderColor: valueColor },
                    { backgroundColor: this.context.colors.empty },
                  ]}
                />
              </TouchableOpacity>
            </HoverableTooltip>
          )}
        </ShelfWrapper>
      </Hoverable>
    );
  };

  renderParentInput = () => {
    let { moment } = this.props;
    let { parentQuery, text, value } = this.state;
    if (!text.includes("#") && !parentQuery?.length) return null;
    return (
      <View>
        <Text trim>Add parent:</Text>
        <Autocomplete
          ref={(r) => (this.searchRef = r)}
          query={parentQuery}
          onChangeText={(text) => {
            this.setState({ parentQuery: text });
          }}
          placeholder={"attribute to..."}
          setFirstSuggestion={(firstParentSuggestion) => {
            this.setState({ firstParentSuggestion });
          }}
          // onEnter={this.handleToggleParent}
          // simpleListView
          captureEnterOnlyWithItem
          onSelectItem={this.handleToggleParent}
          excludeIds={[value.id, moment.value?.id, moment.note?.id]}
          // extraStyle={{ minWidth: 100, flex: 0, borderWidth: 2 }}
          suggestionsOnly
          simpleListView
          suggestChapters
        />
        {!!parentQuery?.length && (
          <Text button numberOfLines={1} onMouseDown={this.handleCreateParent}>
            Create "{parentQuery}"
          </Text>
        )}
      </View>
    );
  };

  handleCreateParent = async () => {
    let { parentQuery, value, text } = this.state;
    let { chapter } = this.props;
    let parent = await valueActions.create(
      {
        text: parentQuery.trim(),
        child_ids: [value.id],
      },
      chapter?.id,
    );
    if (text?.includes("#")) {
      text = text.split("#")[0];
    }
    this.setState({ text, parentQuery: "" });

    this.props.onRefreshChapter && this.props.onRefreshChapter();
    value = store.getState().values.find((v) => v.id == value.id);
    this.setState({ value });
  };

  renderChildInput = () => {
    let { moment } = this.props;
    let { value, text, parentQuery, firstChildSuggestion, noChldSuggestion } =
      this.state;
    if (!text?.length || !!parentQuery?.length) return null;
    return (
      <View>
        <Text trim>
          {!!firstChildSuggestion ? "Add" : "Create"} child
          {!!firstChildSuggestion ? (
            ":"
          ) : (
            <AntDesign
              name="enter"
              color={this.context.colors.trim}
              size={this.context.sizes.default}
              style={{ marginLeft: this.context.sizes.base }}
            />
          )}
        </Text>
        {!noChldSuggestion && (
          <Autocomplete
            ref={(r) => (this.searchRef = r)}
            query={text}
            onChangeText={(text) => {
              this.setState({ text });
            }}
            setFirstSuggestion={(firstChildSuggestion) => {
              this.setState({ firstChildSuggestion });
            }}
            onEnter={this.handleToggleChild}
            // simpleListView
            onSelectItem={this.handleToggleChild}
            excludeIds={[moment.value?.id, moment.note?.id, value.id]}
            captureEnterOnlyWithItem
            suggestionsOnly
            simpleListView
            noGetMore
          />
        )}
      </View>
    );
  };

  renderTags = () => {
    // let { stackTags } = this.props
    let { value, showParents } = this.state;
    let parents = valueHelpers.getParents({
      value,
      includePreviousRevisions: false,
    });
    if (!!parents?.length) {
      return (
        <View
          style={{
            position: "absolute",
            bottom: "100%",
            right: this.context.sizes.small,
            padding: this.context.sizes.tiny,
            paddingLeft: this.context.sizes.small,
            backgroundColor: this.context.colors.fill,
            borderTopRightRadius: this.context.sizes.smallBorderRadius,
            borderTopLeftRadius: this.context.sizes.smallBorderRadius,
          }}
        >
          <HoverableTooltip text="View parents" rightAligned={false}>
            <TouchableOpacity
              onPress={this.toggleParents}
              style={{
                flexDirection: "row",
                justifyContent: "flex-end",
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                }}
              >
                {parents.reverse().map((parent, i) => {
                  return (
                    <Tag
                      includeHash
                      small
                      value={parent}
                      key={`${i}-${parent.id}`}
                      onPress={this.toggleParents}
                    />
                  );
                })}
              </View>
            </TouchableOpacity>
          </HoverableTooltip>
        </View>
      );
    } else {
      return (
        <View
          style={{
            position: "absolute",
            bottom: "100%",
            right: this.context.sizes.small,
            padding: this.context.sizes.tiny,
            paddingLeft: this.context.sizes.small,
            backgroundColor: this.context.colors.fill,
            borderTopRightRadius: this.context.sizes.smallBorderRadius,
            borderTopLeftRadius: this.context.sizes.smallBorderRadius,
          }}
        >
          <HoverableTooltip text="Add Parents" rightAligned={false}>
            <TouchableOpacity
              onPress={this.toggleParents}
              style={{
                flexDirection: "row",
                justifyContent: "flex-end",
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                }}
              >
                <Tag includeHash small value={{ text: "Parents" }} />
              </View>
            </TouchableOpacity>
          </HoverableTooltip>
        </View>
      );
    }
  };

  // embedding-based parent suggestions for this value's content; each "more"
  // press steps to a larger limit AND a lower score floor (raising the limit
  // alone is a no-op once the floor caps the results)
  SUGGEST_STEPS = [
    { limit: 5, minScore: 0.55 },
    { limit: 10, minScore: 0.45 },
    { limit: 15, minScore: 0.35 },
  ];

  suggestParents = async (more = false) => {
    let { value } = this.state;
    if (!value?.id || this.state.suggestingParents) return;
    let step = more
      ? Math.min(
          (this.state.parentSuggestionStep || 0) + 1,
          this.SUGGEST_STEPS.length - 1,
        )
      : 0;
    let { limit, minScore } = this.SUGGEST_STEPS[step];
    this.setState({ suggestingParents: true, parentSuggestionStep: step });
    let text = `${value.title || ""}\n${value.text || ""}`.trim();
    let res = await valueActions.suggestForText(text, limit, minScore);
    // adopted parents land in the store first — filter against the fresh copy
    let storeValue =
      store.getState().values.find((v) => v.id == value.id) || value;
    let existing = [value.id, ...(storeValue.parent_ids || [])];
    let raw = res?.suggestions || [];
    let parentSuggestions = raw.filter((s) => !existing.includes(s.id));
    this.setState({
      suggestingParents: false,
      parentSuggestions,
      parentSuggestionsMaxed: step >= this.SUGGEST_STEPS.length - 1,
    });
  };

  adoptSuggestedParent = async (suggestion) => {
    let { value } = this.state;
    let res = await valueActions.addParent(value, suggestion);
    if (res) {
      this.setState({
        parentSuggestions: this.state.parentSuggestions?.filter(
          (s) => s.id != suggestion.id,
        ),
        expandedSuggestionId: null,
        suggestionRelatives: null,
      });
      this.fetch && this.fetch();
    }
  };

  // expand a suggestion to browse its own parents/children and adopt one of
  // those instead
  expandSuggestion = async (suggestion) => {
    if (this.state.expandedSuggestionId == suggestion.id) {
      this.setState({ expandedSuggestionId: null, suggestionRelatives: null });
      return;
    }
    this.setState({
      expandedSuggestionId: suggestion.id,
      suggestionRelatives: null,
    });

    let deriveRelatives = () => {
      let values = store.getState().values;
      let full = values.find((v) => v.id == suggestion.id);
      if (!full) return null;
      let { value } = this.state;
      let exclude = [value.id, ...(value.parent_ids || [])];
      let filter = (list) => (list || []).filter((v) => !exclude.includes(v.id));
      return {
        parents: filter(
          valueHelpers.getParents({ value: full, includePreviousRevisions: false }),
        ),
        children: filter(
          valueHelpers.getChildren({ value: full, includeNotes: false }),
        ),
      };
    };

    let relatives = deriveRelatives();
    if (!relatives || (!relatives.parents.length && !relatives.children.length)) {
      // suggestion not in the local store (or relations unloaded) — fetch it,
      // which also dispatches its parents/children into the store
      await valueActions.get(suggestion.id);
      relatives = deriveRelatives() || { parents: [], children: [] };
    }
    // bail if the user already collapsed or switched selection meanwhile
    if (this.state.expandedSuggestionId != suggestion.id) return;
    this.setState({ suggestionRelatives: relatives });
  };

  renderParentSuggestions = () => {
    let { suggestingParents, parentSuggestions } = this.state;
    let subtle = {
      fontSize: this.context.sizes.smallFont,
      color: this.context.colors.trim,
    };
    // idle/empty states render as a small link anchored to the far right of
    // the "+ Add a parent" composer row (the last row of the parents list)
    if (parentSuggestions == null || !parentSuggestions.length) {
      return (
        <Text
          style={[
            subtle,
            {
              position: "absolute",
              right: this.context.sizes.base,
              bottom: this.context.sizes.base,
            },
          ]}
          onPress={() =>
            parentSuggestions == null
              ? this.suggestParents()
              : this.setState({ parentSuggestions: null })
          }
        >
          {suggestingParents
            ? "suggesting…"
            : parentSuggestions == null
            ? "suggest parents"
            : "no suggestions"}
        </Text>
      );
    }
    return (
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          flexWrap: "wrap",
          paddingHorizontal: this.context.sizes.base,
          paddingBottom: this.context.sizes.small,
        }}
      >
        {(
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            {parentSuggestions.map((s) => (
              <View
                key={s.id}
                style={{ flexDirection: "row", alignItems: "center" }}
              >
                <Tag
                  small
                  icon
                  maxWidth={220}
                  value={s}
                  onPress={() => this.adoptSuggestedParent(s)}
                />
                <Text
                  style={[
                    subtle,
                    {
                      paddingRight: this.context.sizes.small,
                      marginLeft: -this.context.sizes.tiny,
                    },
                  ]}
                  onPress={() => this.expandSuggestion(s)}
                >
                  {this.state.expandedSuggestionId == s.id ? "▾" : "▸"}
                </Text>
              </View>
            ))}
            {!this.state.parentSuggestionsMaxed && (
              <Text
                style={[
                  subtle,
                  { paddingHorizontal: this.context.sizes.small },
                ]}
                onPress={() => this.suggestParents(true)}
              >
                {suggestingParents ? "…" : "more"}
              </Text>
            )}
            <Text
              style={[subtle, { paddingHorizontal: this.context.sizes.small }]}
              onPress={() =>
                this.setState({
                  parentSuggestions: null,
                  expandedSuggestionId: null,
                  suggestionRelatives: null,
                })
              }
            >
              ✕
            </Text>
            {!!this.state.expandedSuggestionId &&
              this.renderSuggestionRelatives(subtle)}
          </View>
        )}
      </View>
    );
  };

  renderSuggestionRelatives = (subtle) => {
    let { suggestionRelatives } = this.state;
    let row = (label, relatives) =>
      !!relatives?.length && (
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            flexWrap: "wrap",
            marginTop: this.context.sizes.tiny,
          }}
        >
          <Text style={[subtle, { marginRight: this.context.sizes.small }]}>
            {label}
          </Text>
          {relatives.map((v) => (
            <Tag
              key={v.id}
              small
              icon
              maxWidth={220}
              value={v}
              onPress={() => this.adoptSuggestedParent(v)}
            />
          ))}
        </View>
      );
    return (
      <View
        style={{
          width: "100%",
          paddingLeft: this.context.sizes.base,
          borderLeftWidth: 1,
          borderColor: this.context.colors.trim,
          marginTop: this.context.sizes.tiny,
        }}
      >
        {suggestionRelatives == null ? (
          <Text style={subtle}>loading…</Text>
        ) : !suggestionRelatives.parents?.length &&
          !suggestionRelatives.children?.length ? (
          <Text style={subtle}>no parents or children</Text>
        ) : (
          <View>
            {row("parents:", suggestionRelatives.parents)}
            {row("children:", suggestionRelatives.children)}
          </View>
        )}
      </View>
    );
  };

  renderParents = () => {
    let { moment, horizontal } = this.props;
    let { value, fetchingParents, showParents } = this.state;

    if (fetchingParents) {
      let color = valueHelpers.getColor(value, this.context.colorScheme);
      return (
        <View
          style={{
            // position: "absolute",
            // bottom: "100%",
            padding: this.context.sizes.small,
            left: 0,
            right: 0,
            // left: -this.context.sizes.bulletWidth,
            alignItems: "flex-start",
            backgroundColor: this.context.colors.fill,
          }}
        >
          <ActivityIndicator color={color} />
        </View>
      );
    }

    let parents = valueHelpers.getParents({
      value,
      includePreviousRevisions: false,
    });
    return (
      <View
        style={{
          // position: "absolute",
          // bottom: "100%",
          // left: -this.context.sizes.bulletWidth,
          backgroundColor: this.context.colors.fill,
          // marginLeft: -this.context.sizes.large,
          // backgroundColor: colorHelpers.hexToRgbaString(
          //   this.context.colors.trim,
          //   0.2
          // ),
          borderColor: this.context.colors.empty,
          borderBottomWidth: 2,
          borderTopWidth: 2,
        }}
      >
        <RecursiveMomentList
          composerPlaceholder={"Add a parent"}
          onSelectValue={this.props.onSelectValue}
          onBrowseEscape={this.props.onBrowseEscape}
          valueMoments={this.state.valueMoments}
          valueMomentsChapters={this.state.valueMomentsChapters}
          passthruRef={(ref) => (this.parentListRef = ref)}
          rootChapter={this.props.rootChapter}
          moments={parents.map((value) => ({
            value,
            id: `parent-${value.id}`,
          }))}
          onRefreshChapter={this.props.onRefreshChapter}
          onRefreshMoment={this.fetch}
          // focusParentMoment={this.props.focusParentMoment}
          focusParentMoment={() => {
            this.inputRef?.focus();
          }}
          // rightAlign
          parentIsValue
          parentId={value.id}
          parentIsChild
          collapseParent={() => this.toggleExpanded(false)}
          onPinToParentChapter={this.props.onPinToParentChapter}
          // horizontal={horizontal}
          // badgeScale={(this.props.badgeScale || 1) + 0.5}
          onEscape={() => {
            if (!!this.props.onEscape) {
              this.props.onEscape();
            } else if (showParents) {
              this.toggleParents();
              this.inputRef?.focus();
            }
          }}
        />
        {this.renderParentSuggestions()}
      </View>
    );
  };

  renderChildren = () => {
    let { moment, horizontal, chapterMoments } = this.props;
    let {
      value,
      expanded,
      fetching,
      hasUnscopedChildren,
      scopedChildIds,
      scopingToChapter,
      isHovered,
      hidePinnedChildren,
      focused,
    } = this.state;
    if (!!moment.category) return;

    // let chapterValues = chapterMoments?.map((m) => m.value);
    // let chapterValueIds = chapterMoments?.map((m) => m.value.id);

    let pinnedChildren = hidePinnedChildren
      ? []
      : chapterMoments?.filter(
          // filter to only children values
          (moment) =>
            moment.value?.parent_ids?.includes(value.id) &&
            (true ||
              (moment.value.color == value.color &&
                moment.value.icon == value.icon)),
        );

    // remove pinned grand-children values
    // if one of my children also has this value as a child, then remove it from my pinned list
    let pinnedChildrenValueIds = pinnedChildren?.map((m) => m.value.id) || [];
    pinnedChildrenValueIds.filter((v) => v != value.id);

    pinnedChildren = pinnedChildren?.filter(
      (moment) =>
        !moment.value.parent_ids?.filter((pid) =>
          pinnedChildrenValueIds.includes(pid),
        ).length,
    );

    if (!expanded && !pinnedChildren?.length) return null;

    let color = valueHelpers.getColor(value, this.context.colors);

    let pinnedMomentList = false;
    let pinnedMomentParent = null;

    let moments = [];
    // let unscopedMoments = [];
    if (!expanded && !!pinnedChildren?.length) {
      pinnedMomentParent = moment;
      pinnedMomentList = true;
      moments = pinnedChildren;
    } else {
      // let children = valueHelpers.getChildren({
      //   value,
      //   sort: "list",
      //   includeNotes: true,
      // });
      let children = valueHelpers.getChildren({
        value,
        includeNotes: true,
        includePreviousRevisions: false,
      });

      // children = children.filter((c) => !c.is_note || !c.completed_at); // remove complete notes
      // snooze mutes suggestions only — an explicit child stays listed
      let activeChildren = children.filter((c) => !c.archived_at); // remove inactive values
      if (activeChildren?.length) {
        // only if that's not all there is
        children = activeChildren;
      }

      // unscopedMoments =
      //   children?.map((v) => ({ value: v, id: `child-${v.id}` })) || [];

      if (scopingToChapter && !!scopedChildIds?.length) {
        children = children.filter((c) => scopedChildIds.includes(c.id));
      }
      moments =
        children?.map((v) => {
          let m = { value: v, id: `child-${v.id}` };
          let pinnedMoment = pinnedChildren?.find((m) => m.value_id == v.id);
          if (!!pinnedMoment) m = pinnedMoment;
          return m;
        }) || [];
      // console.log("bullet moment children", unscopedMoments, moments);
    }

    // if (!moments.length && value.is_note) return null;

    return (
      <View
        style={{
          // position: "absolute",
          // backgroundColor: this.context.colors.fill,
          marginLeft: this.context.sizes.largeBulletWidth / 2,
          marginTop: ENV.WEB
            ? -this.context.sizes.large / 2
            : this.context.sizes.small,
          marginBottom: this.props.pinnedMomentList
            ? 0
            : ENV.WEB
              ? this.context.sizes.small
              : this.context.sizes.default,
          zIndex: isHovered ? 0 : 2,
        }}
      >
        <View
          style={{
            borderLeftWidth: expanded ? 1 : 0,
            borderColor: colorHelpers.hexToRgbaString(color, 0.6),
            paddingLeft: expanded ? this.context.sizes.bulletWidth / 2 : 0,
          }}
        >
          <RecursiveMomentList
            composerPlaceholder={"Add items..."}
            onSelectValue={this.props.onSelectValue}
            onBrowseEscape={this.props.onBrowseEscape}
            valueMoments={this.state.valueMoments}
            valueMomentsChapters={this.state.valueMomentsChapters}
            moment={moment}
            onUpdateMoment={this.props.onUpdateMoment}
            passthruRef={(ref) => (this.childListRef = ref)}
            rootChapter={this.props.rootChapter}
            onPinToParentChapter={this.props.onPinToParentChapter}
            // scopeToChapter={this.props.rootChapter?.id == this.props.chapter?.id}
            moments={moments}
            // unscopedMoments={unscopedMoments}
            // scopedChildIds={scopingToChapter ? scopedChildIds : []}
            pinnedMomentList={pinnedMomentList}
            // chapter={pinnedMomentList ? chapter : null}
            pinnedMomentParent={pinnedMomentParent}
            chapterMoments={chapterMoments}
            progress_at={value.progress_at}
            value={value}
            onRefreshChapter={this.props.onRefreshChapter}
            onRefreshMoment={this.fetch}
            focusParentMoment={this.props.focusParentMoment}
            parentIsValue
            timestamp={moment?.completed_at || moment?.created_at}
            parentId={value.id}
            hideScrathpadPreview={this.props.hideScrathpadPreview}
            focusNextUncle={() => {
              this.props.focusNext && this.props.focusNext(true);
            }}
            // this.inputRef?.focus();
            nestedChildrenView={!expanded}
            horizontal={horizontal}
            hideTags={this.props.hideTags}
            hideBadgeRow={this.props.hideBadgeRow}
            expanded={this.props.expanded && this.props.recursiveExpanded}
            parentExpanded={expanded}
            parentFocused={focused}
            preventAutoFocus={this.props.preventAutoFocus}
            valueBadges={this.props.valueBadge}
            collapseParent={() => this.toggleExpanded(false)}
            onFocusChapterTitle={this.props.focusParentMoment}
            onFocusNextChapter={this.props.onFocusNextChapter}
            onFocusPreviousChapter={this.props.onFocusPreviousChapter}
            // hideComposer={loading}
            getUnscopedChildren={
              !!hasUnscopedChildren &&
              scopingToChapter &&
              !!scopedChildIds?.length
                ? () => {
                    // !!hasUnscopedChildren ? () => this.fetch(false) : null
                    this.setState({ scopingToChapter: false });
                  }
                : null
            }
            onExpandMoment={this.props.onExpand}
            onCollapseMoment={this.props.onCollapse}
          />
          {fetching && (
            <View
              style={{
                position: "absolute",
                bottom: 0,
                left: this.context.sizes.bulletWidth,
              }}
            >
              <ActivityIndicator color={color} />
            </View>
          )}
        </View>
      </View>
    );
  };

  renderContextString = () => {
    let { moment, chapter } = this.props;
    chapter = chapter || moment.chapter;
    let title = chapterHelpers.getTitle(chapter, false, true);
    return <Text trim>{title}</Text>;
  };

  renderAttribution = () => {
    let { moment } = this.props;
    let value = moment.value;
    if (!!value.attribution_ids?.length) {
      let values = store.getState().values;
      let vals = values.filter((v) => value.attribution_ids.includes(v.id));
      return (
        <View style={{ flexDirection: "row" }}>
          {vals.reverse().map((val, i) => {
            return (
              <Tag
                small
                icon
                value={val}
                key={`${i}-${val.id}`}
                onPress={(e) =>
                  RootNavigation.push("Project", { id: val.id }, e)
                }
              />
            );
          })}
          <View
            style={{
              width: this.context.sizes.large,
              height: this.context.sizes.large,
              justifyContent: "center",
              alignItems: "center",
              borderRadius: 99,
              backgroundColor: this.context.colors.trim,
              marginRight: 4,
            }}
          >
            <Text small style={{}}>
              {value.attribution_score}
            </Text>
          </View>
        </View>
      );
    }
  };

  renderProgressBar = () => {
    let { moment, chapter, chapterMoments } = this.props;
    let { value } = this.state;
    if (moment.range == 1) return null;
    if (value?.category == "narration") return null;

    let pinnedMoments = [];
    for (let i = 0; i < moment.sub_chapter_count; i++) {
      pinnedMoments.push(i);
    }

    // let pinnedMoments = moment.sub_chapter_moments || [];

    // let pinnedMoments = chapterMoments?.filter((m) => m.value_id == value.id);
    let color = valueHelpers.getColor(value, this.context.colorScheme);
    // if (!pinnedMoments?.length) return null;

    return (
      <View
        style={{
          position: "absolute",
          top: "100%",
          left: 4,
          marginTop: -4,
          flexDirection: "row",
          right: 0,
          overflow: "hidden",
        }}
      >
        {pinnedMoments.map((m) => {
          return (
            <View
              key={m.id}
              style={{
                height: 2,
                width: 10,
                backgroundColor: color,
                // opacity: !!m.completed_at ? 1 : 0.3,
                opacity: 0.5,
                marginRight: 5,
              }}
            ></View>
          );
        })}
      </View>
    );
  };

  // cmd/shift-click on a pin-elsewhere action means "move": also remove the
  // moment from the chapter it's currently on
  isMoveClick = (e) =>
    !!(
      e?.metaKey ||
      e?.shiftKey ||
      e?.nativeEvent?.metaKey ||
      e?.nativeEvent?.shiftKey
    );

  removeCurrentPin = async () => {
    let { moment } = this.props;
    if (!moment?.id) return;
    await momentActions.delete(moment.id, false);
    this.props.onRefreshChapter && this.props.onRefreshChapter();
  };

  renderScheduler = () => {
    let { showScheduler, value, momentTimestamps } = this.state;
    let { chapter } = this.props;
    if (!showScheduler) return null;
    let timestamps = momentTimestamps.map((t) =>
      timeHelpers.dateToDateTime(t.date),
    );
    return (
      <View style={{ height: 400 }}>
        <DatePicker
          inline
          dateOnly
          value={
            !!chapter?.start_at
              ? timeHelpers.dateToDateTime(chapter.start_at)
              : new Date()
          }
          highlightDates={[
            {
              "react-datepicker__day--highlighted-custom-3": timestamps,
            },
          ]}
          haptics={false}
          onChange={async (dt, event) => {
            // web react-datepicker passes the click event as 2nd arg
            let move = this.isMoveClick(event);
            let date = timeHelpers.dateTimeToDate(dt);
            let mt = momentTimestamps.find((mt) => mt.date == date);
            if (!!mt) {
              let res = await momentActions.delete(
                mt.moment_id,
                "Remove item from selected date?",
              );
              if (!res) return;
            } else {
              let res = await chapterActions.pinValueByDate(date, value);
              if (!res.success) return;
              else {
                momentTimestamps.push({
                  moment_id: res.moment.id,
                  date: res.chapter.start_at,
                });
                this.setState({ momentTimestamps });
                if (move && res.chapter?.id != this.props.chapter?.id) {
                  await this.removeCurrentPin();
                }
              }
            }
            haptics.warn();
            this.setState({ showScheduler: false, showButtons: false });
          }}
        />
      </View>
    );
  };

  toggleShowScheduler = async () => {
    let { showScheduler, value } = this.state;
    let newShowScheduler = !showScheduler;
    this.setState({ showScheduler: !showScheduler });
    if (newShowScheduler) {
      let res = await valueActions.fetchMoments(value?.id);
      if (res.success) {
        this.setState({
          moments: res.moments,
          momentTimestamps: res.timestamps,
          // showButtons: false,
        });
      }
    }
  };

  handleFocusFirstChild = () => {
    // Visual order inside the expanded bullet: scratchpad → moments log → children
    if (this.childListRef?.tryFocusScratchPad && this.childListRef.tryFocusScratchPad()) {
      return;
    }
    if (this.childListRef?.tryFocusMomentLog && this.childListRef.tryFocusMomentLog()) {
      return; // Successfully focused momentlog
    }
    // Otherwise focus first child moment as before
    this.childListRef?.handleFocusFirstMoment &&
      this.childListRef.handleFocusFirstMoment();
  };

  handleToggleParent = async (parent) => {
    let { value, parentQuery, text } = this.state;
    let { moment, chapter } = this.props;

    this.setState({ fetching: true });

    if (parent.type == "chapter") {
      let targetChapter = parent;
      console.log("CHAPTER", targetChapter);
      let res = await chapterActions.pinValue(targetChapter.id, value.id);
      console.log(res);
    } else {
      await valueActions.toggleParent(value, parent);
    }

    if (text?.includes("#")) {
      text = text.split("#")[0];
    }
    this.setState({ text, parentQuery: "", fetching: false });

    this.props.onRefreshChapter && this.props.onRefreshChapter();
    value = store.getState().values.find((v) => v.id == value.id);
    this.setState({ value });

    // await chapterActions.maybeAttributeToParentChapter(chapter)
    // this should be a dynamic value instead, the opposite of 'suggestions'
    // if a chapter's sub-chapters have values with parents, those parents should propgate up as inverted suggestions
  };

  handleToggleChild = async (child) => {
    console.log(child);
    let { moment, chapter } = this.props;
    let { value, text } = this.state;
    if (value.child_ids.includes(child.id)) {
      await valueActions.removeChild(value, child);
    } else {
      await valueActions.addChild(value, child);
    }
    this.setState({ text: "", parentQuery: "" });

    this.props.onRefreshChapter && this.props.onRefreshChapter();
    value = store.getState().values.find((v) => v.id == value.id);
    this.setState({ value });

    // await chapterActions.maybeAttributeToParentChapter(chapter)
    // this should be a dynamic value instead, the opposite of 'suggestions'
    // if a chapter's sub-chapters have values with parents, those parents should propgate up as inverted suggestions
  };

  handleAddChild = async (child) => {
    let { moment, chapter } = this.props;
    let { value } = this.state;
    console.log(child);
    await valueActions.addChild(value, child);

    this.props.onRefreshChapter && this.props.onRefreshChapter();

    this.setState({ childQuery: "" });
  };

  handleDeleteMoment = async (prompt = true) => {
    let {
      moment,
      parentIsValue,
      parentId,
      parentIsChild,
      chapterMoments,
      rootChapter,
      expanded,
    } = this.props;

    if (!!this.props.handleDelete) {
      this.props.handleDelete(moment?.value?.id);
      this.props.focusNext && this.props.focusNext();
      return;
    }

    if (moment?.suggestion) {
      const { chapter } = this.props;
      if (chapter) chapterActions.dismissSuggestion(chapter, moment.value?.id);
      this.props.focusNext && this.props.focusNext();
      return;
    }

    let pinnedMoment =
      !rootChapter?.is_value &&
      chapterMoments?.find((m) => m.value_id == moment.value.id);

    // console.log(pinnedMoment, chapterMoments, moment);

    if (parentIsValue && parentIsChild) {
      let res = await alertActions.confirm({
        title: `Remove parent?`,
        text: "Remove",
        options: ["Archive relationship"],
      });
      if (res === 1 || res === 2) {
        this.props.focusNext && this.props.focusNext();
        this.parentListRef?.handleFocusComposer();
        if (res === 1) {
          await valueActions.removeChild({ id: moment.value.id }, { id: parentId });
        } else {
          await valueActions.archiveChild({ id: moment.value.id }, { id: parentId });
        }
      }
      return;
    }

    if (parentIsValue && !pinnedMoment) {
      let res = await alertActions.confirm({
        title: `Remove child?`,
        text: "Remove",
        options: ["Archive relationship"],
      });
      if (res === 1) {
        valueActions.removeParent({ id: moment.value.id }, { id: parentId });
      } else if (res === 2) {
        valueActions.archiveParent({ id: moment.value.id }, { id: parentId });
      }
    } else {
      let res = await momentActions.delete(pinnedMoment.id, prompt);
      console.warn(pinnedMoment.id, res);
      if (res?.success) {
        this.props.focusNext && this.props.focusNext();
        this.props.onRefreshChapter && this.props.onRefreshChapter();
      }
    }
  };

  handleSnoozeForWeek = async () => {
    let { moment } = this.props;
    if (!moment?.value?.id) return;
    if (this.props.handleSnoozeWeek) {
      this.props.handleSnoozeWeek(moment.value.id);
      this.props.focusNext && this.props.focusNext();
      return;
    }
    // fallback: generic 7-day snooze for non-rollover suggestions
    const snoozeUntil = new Date();
    snoozeUntil.setDate(snoozeUntil.getDate() + 7);
    snoozeUntil.setHours(0, 0, 0, 0);
    await valueActions.update(moment.value.id, { snooze_until: snoozeUntil.toISOString() });
    toastActions.show("Suggestion snoozed for 7 days");
    this.props.focusNext && this.props.focusNext();
  };

  handleBadgePress = (event) => {
    let { value, expanded } = this.state;
    if (event.button == 1 || event.metaKey || event.newTab) {
      RootNavigation.navigate("Project", { id: value.id }, event);
    } else {
      // if (!!this.props.chapter)
      //   momentActions.update(this.props.moment.id, {
      //     stance: expanded ? "collapsed" : "expanded",
      //   });
      this.toggleExpanded();
    }
  };

  toggleExpanded = async (force = null, forceOneline = null) => {
    let {
      expanded,
      value,
      showParents,
      hideText,
      hasPinnedChildren,
      hidePinnedChildren,
      type,
    } = this.state;
    // console.log(this.props.moment);
    console.error(`force: ${force}, expanded: ${expanded}`);

    if (force == false && expanded == false) {
      if (showParents) {
        !!this.props.onCollapseParent && this.props.onCollapseParent();
        return;
      } else if (!hidePinnedChildren) {
        this.setState({ hidePinnedChildren: true, expanded: false });
        return;
      }
    }
    let newExpanded = !expanded;
    let newHidePinnedChildren = false;
    if (force === true || force === false) newExpanded = force;
    if (!newExpanded) showParents = false;
    let newOneline = forceOneline !== null ? forceOneline : !newExpanded;
    if (
      forceOneline == true &&
      !value.child_ids?.length &&
      !value.text?.length
    ) {
      this.setState({ expanded: false, hidePinnedChildren: false });
      this.props.onCollapse && this.props.onCollapse(value);
      return;
    }
    await this.setState({
      expanded: newExpanded,
      hidePinnedChildren: newHidePinnedChildren,
      showParents,
      oneline: newOneline,
    });
    if (newExpanded) this.props.onExpand && this.props.onExpand(value);
    else this.props.onCollapse && this.props.onCollapse(value);

    if (type == "progress") return;

    if (!newExpanded) {
      this.setState({ scopingToChapter: true });
      if (ENV.WEB) this.inputRef?.focus();
      // } else if (newExpanded && value.has_children && !value.children?.length) {
    } else if (newExpanded) {
      // let scopeToChapter = this.props.scopeToChapter || false;
      let scopeToChapter = true;
      if (expanded == true && newExpanded == true) scopeToChapter = false; // double-expand, show all!
      this.fetch(scopeToChapter);
    }
  };

  toggleParents = async () => {
    let { value, showParents } = this.state;
    showParents = !showParents;
    this.setState({ showParents });

    if (showParents) {
      await this.setState({ fetchingParents: true });
      await valueActions.getFamily(value.id, { up: 1, down: 0 });
      await this.setState({ fetchingParents: false });
    }
  };

  fetch = async (scopeToChapter = true) => {
    if (!scopeToChapter && this.state.fetched) {
      this.setState({ scopingToChapter: false });
      return;
    }
    let { rootChapter, moment } = this.props;
    let { value } = this.state;
    if (!!moment.category) return;
    console.log(value, this.props.moment);
    await this.setState({ fetching: true });
    // console.log("before", value);
    let res = await valueActions.get(
      value.id,
      scopeToChapter && !rootChapter?.is_value && rootChapter?.id,
    );
    this.setState({ fetching: false });
    console.log(res);
    if (!!res?.value) {
      let scopedChildIds = this.state.scopedChildIds;
      if (scopeToChapter) {
        // scopedChildIds = res.children.map((c) => c.id);
        scopedChildIds = res.scoped_children.map((c) => c.id);
        console.log("after scroping", scopedChildIds);
      }
      this.setState({
        fetched: true,
        value: res.value,
        valueMoments: res.moments,
        valueMomentsChapters: res.chapters,
        scopedChildIds,
        hasUnscopedChildren: res.has_unscoped_children,
        scopingToChapter: scopeToChapter,
      });
    }
  };

  handleToggleNote = async () => {
    let { value } = this.state;
    console.log("handleToggleNote", value);
    this.setState({ loading: true });
    let res = await valueActions.toggleIsNote(value);
    // this.setState({ loading: false });
    if (res) {
      // this.setState({ value: { ...value, is_note: !value.is_note } });
      // this.props.onRefreshChapter && this.props.onRefreshChapter();
    }
  };

  handleAltEnter = async () => {
    // pin to today
    let { moment } = this.props;
    let { value } = this.state;
    let valueId = value?.id || moment.value?.id || moment.value_id;
    let res = await chapterActions.pinValue("today", valueId);
    this.props.onRefreshChapter && this.props.onRefreshChapter();
    haptics.light();
  };

  handleEnter = async () => {
    // selection override: when this bullet is browsed from a composer's
    // suggestion list, Enter selects the value into the composer (pin /
    // relationship) instead of progressing it — inherited recursively by
    // the bullet's parent/child lists
    if (!!this.props.onSelectValue) {
      let value = this.state.value || this.props.moment?.value;
      if (!!value?.id) this.props.onSelectValue(value);
      return;
    }
    // create parent, or log progress, or undo progress
    let { chapter, moment } = this.props;
    let {
      text,
      parentQuery,
      firstParentSuggestion,
      firstChildSuggestion,
      timestamp,
      rootChapter,
    } = this.state;
    let value = this.state.value || moment?.value;
    let valueId = value?.id || moment.value_id;

    if (moment.suggestion) {
      await chapterActions.pinValue(chapter.id, value.id);
      chapterActions.undismissSuggestion(chapter, value.id);
      valueActions.removeSnooze(value.id);
      this.props.focusNext && this.props.focusNext();
      return;
    }

    await this.setState({
      loading: true,
      showButtons: false,
      badgeIsHovered: false,
    });
    await new Promise((r) => setTimeout(r, 0));

    // create parent
    if (!!parentQuery) {
      if (!!firstParentSuggestion) {
        this.handleToggleParent(firstParentSuggestion);
        return;
      } else {
        let res = await valueActions.create(
          {
            title: parentQuery,
            child_ids: [valueId],
          },
          chapter?.id,
        );
        if (text?.includes("#")) {
          text = text.split("#")[0];
        }
        this.setState({ text, parentQuery: "" });
        return;
      }
    }

    // log progress    ;
    if (!moment.completed_at) {
      let res = await valueActions.progress(
        value.id,
        timestamp,
        false,
        moment?.id,
        true,
      );
      console.log("progress res", res);
      this.props.onRefreshChapter && this.props.onRefreshChapter();
      return;
    }

    // undo progress
    if (!!moment.completed_at) {
      if (!!value.completed_at) {
        // uncomplete value
        this.handleMetaEnter();
      } else {
        // uncomplete moment
        let res = await momentActions.uncomplete(moment.id);
        // delete associated progress_at
        let lastProgressAt = value.progress_at[value.progress_at.length - 1];
        if (!!chapter?.start_at) {
          lastProgressAt = value.progress_at.reverse().find((p) => {
            if (
              new Date(p).getTime() <
              timeHelpers
                .endOfDay(timeHelpers.dateToDateTime(chapter.end_at))
                .getTime()
            ) {
              if (
                new Date(p).getTime() >
                timeHelpers.dateToDateTime(chapter.start_at).getTime()
              ) {
                return true;
              }
            }
            return false;
          });
        }
        if (!!lastProgressAt) {
          let pRes = await valueActions.deleteProgress(value, lastProgressAt);
        }
        !!this.props.onUpdateMoment &&
          this.props.onUpdateMoment({
            ...moment,
            completed_at: res.moment.completed_at,
          });
        this.props.onRefreshChapter && this.props.onRefreshChapter();
        return;
      }
    }
  };

  handlCycleCategory = async () => {
    let { value } = this.state;
    let categoryOptions = ["topic", "project", "event"]; //, "note"];
    // let categoryOptions = ["infinite", "finite", ...];
    let categoryIndex = categoryOptions.indexOf(value.category);
    let newCategoryIndex = categoryIndex + 1;
    if (newCategoryIndex >= categoryOptions.length) newCategoryIndex = 0;
    let category = categoryOptions[newCategoryIndex];
    let res = await valueActions.update(value.id, { category });
  };

  handleMetaEnter_LEGACY = async (prompt = true) => {
    let { timestamp, value, valueMoments } = this.state;
    let { moment, chapter, parentIsValue, parentId } = this.props;

    if (typeof moment.id == "number" && !!value?.id) {
      if (!!moment.completed_at) {
        let res = 1;
        if (value.completed_at && value.quota !== null) {
          res = await alertActions.confirm({
            options: ["Delete progress", "Keep item open"],
            // title: ''
            // subtitle: ''
          });
        }
        if (res == 1) {
          valueActions.deleteProgress(value, moment.completed_at, false);
          let res = await momentActions.uncomplete(moment.id);
        } else if (res == 2) {
          valueActions.update(value.id, { quota: 0, completed_at: null });
        }
      } else {
        let res = await valueActions.progress(
          value.id,
          timestamp,
          false,
          moment?.id,
        );
        console.log("progress res", res);
      }
      this.props.onRefreshChapter && this.props.onRefreshChapter();
      return;
    } else if (parentIsValue) {
      // continue
    } else {
      alert("improper moment or value");
      return;
    }

    // console.log(chapter);
    // let momentId = !!chapter?.id ? moment.id : null;
    let momentId = moment.id;
    if (value) {
      this.setState({ loading: true, showButtons: false });
      let res = await valueActions.complete(
        { ...value, moments: valueMoments },
        timestamp,
        prompt,
        momentId,
      );
      // this.setState({ loading: false });
      // console.log(this.inputRef);
      this.inputRef?.focus();
      if (!!res) {
        // this.props.onRefreshChapter && this.props.onRefreshChapter();
      }
    }
  };

  handleEnter_LEGACY = async () => {
    let res, newValue;
    let { chapter, moment } = this.props;
    let {
      text,
      parentQuery,
      firstParentSuggestion,
      firstChildSuggestion,
      timestamp,
      value,
    } = this.state;
    let valueId = value?.id || moment.value?.id || moment.value_id;

    console.log(firstParentSuggestion);
    // return;

    await this.setState({
      loading: true,
      showButtons: false,
      badgeIsHovered: false,
    });
    await new Promise((r) => setTimeout(r, 0));

    if (!!parentQuery) {
      if (!!firstParentSuggestion) {
        this.handleToggleParent(firstParentSuggestion);
        return;
      } else {
        res = await valueActions.create(
          {
            title: parentQuery,
            child_ids: [valueId],
          },
          chapter?.id,
        );
        if (text?.includes("#")) {
          text = text.split("#")[0];
        }
        this.setState({ text, parentQuery: "" });
      }
    } else if (!!text && !!firstChildSuggestion) {
      this.handleToggleChild(firstChildSuggestion);
      return;
    } else if (!!valueId && !!text?.length) {
      if (!!chapter?.id && !chapter?.is_value) {
        // create child node
        alert("what did you expect to happen here?");
        return;
        res = await valueActions.create(
          {
            title: parentQuery,
            parent_ids: [valueId],
          },
          chapter?.id,
        );
        // res = chapterActions.createValue(chapter.id, {
        //   text,
        //   // completed_at: new Date(),
        //   parent_id: valueId,
        // });
        if (res?.success) {
          newVal = res.value;
        }
      } else {
        newValue = valueActions.create({
          text,
          parent_ids: [valueId],
        });
      }
      if (!!newValue) {
        if (!!res?.chapter)
          this.props.onUpdateChapter && this.props.onUpdateChapter(res.chapter);
        else this.props.onRefreshChapter && this.props.onRefreshChapter();
        await this.setState({
          text: "",
          parentQuery: "",
          expandAfterLoading: true,
        });
      }
      return;
    } else if (moment.suggestion) {
      // pin suggestion
      res = chapterActions.pinValue(chapter.id, value.id, {
        // completed_at: new Date(),
        // text: nextText,
      });
    } else if (!!moment.completed_at && !valueHelpers.getRipe(value)) {
      if (!!value.completed_at) {
        // uncomplete value
        // alert("uncomplete value and moment?");
        this.handleMetaEnter();
      } else {
        // uncomplete moment
        res = await momentActions.uncomplete(moment.id);
        // delete associated progress_at
        let lastProgressAt = value.progress_at[value.progress_at.length - 1];
        if (!!chapter?.start_at) {
          lastProgressAt = value.progress_at.reverse().find((p) => {
            if (
              new Date(p).getTime() <
              timeHelpers
                .endOfDay(timeHelpers.dateToDateTime(chapter.end_at))
                .getTime()
            ) {
              if (
                new Date(p).getTime() >
                timeHelpers.dateToDateTime(chapter.start_at).getTime()
              ) {
                return true;
              }
            }
            return false;
          });
        }
        if (!!lastProgressAt) {
          let pRes = await valueActions.deleteProgress(value, lastProgressAt);
        }
        !!this.props.onUpdateMoment &&
          this.props.onUpdateMoment({
            ...moment,
            completed_at: res.moment.completed_at,
          });
        return;
        // alert("uncomplete just the moment? keep the progress?");
      }
      return;
    } else {
      // complete moment (create progress)
      // res = await momentActions.complete(moment.id, timestamp);
      // res = await valueActions.progress(value.id, timestamp, false, moment?.id);
      this.setState({ loading: false });
      return;
    }

    if (res?.success) {
      if (!!res?.value) {
        // this.setState({ value: res.value }); // let redux do this
      }
      if (!!res?.moment) {
        // let { moments, onUpdateMoments } = this.props;
        // let index = moments.findIndex((m) => m.id == moment.id);
        // moments[index] = res.moment;
        // console.log(index, moments[index]);
        // onUpdateMoments(moments);
      }
      this.props.onRefreshChapter && this.props.onRefreshChapter();
    }
  };

  handleMetaEnter = async (prompt = true) => {
    let { timestamp, value } = this.state;
    let { moment, chapter, parentIsValue, parentId } = this.props;

    if (moment.suggestion) {
      // pin the suggestion AND complete the new moment in one step
      await chapterActions.pinValue(chapter.id, value.id, {
        completed_at: new Date(),
      });
      chapterActions.undismissSuggestion(chapter, value.id);
      valueActions.removeSnooze(value.id);
      this.props.focusNext && this.props.focusNext();
      return;
    }

    if (typeof moment.id == "number" && !!value?.id) {
      if (!!moment.completed_at) {
        // let res = 1;
        // if (value.completed_at && value.quota !== null) {
        //   res = await alertActions.confirm({
        //     options: ["Delete progress", "Keep item open"],
        //   });
        // }
        // if (res == 1) {
        valueActions.deleteProgress(value, moment.completed_at, false);
        let res = await momentActions.uncomplete(moment.id);
        // } else if (res == 2) {
        //   valueActions.update(value.id, { quota: 0, completed_at: null });
        // }
        if (!!value.completed_at) {
          this.toggleValueComplete(prompt);
        } else {
          this.props.onRefreshChapter && this.props.onRefreshChapter();
        }
      } else {
        this.toggleValueComplete(prompt);
      }
      return;
    } else if (parentIsValue) {
      this.toggleValueComplete(prompt);
    } else {
      alert("improper moment or value");
      return;
    }
  };

  toggleValueComplete = async (prompt = true) => {
    let { timestamp, value, valueMoments } = this.state;
    let { moment, chapter, parentIsValue, parentId } = this.props;
    let momentId =
      !parentIsValue && typeof moment?.id == "number" ? moment.id : null;
    this.setState({ loading: true, showButtons: false });
    let res = await valueActions.complete(
      { ...value, moments: valueMoments },
      timestamp,
      prompt,
      momentId,
    );
    if (!!res) {
      this.props.onRefreshChapter?.();
      this.inputRef?.focus();
    }
  };

  handleChangeText = async (text) => {
    if (!this.state.isEditable) return;
    if (text.includes("#")) return;
    if (this.updateTimeout) clearTimeout(this.updateTimeout);
    this.updateTimeout = setTimeout(this.updateValue, 1000);
  };

  updateValue = async () => {
    // console.log("automatic updates disabled");
    // return;
    let { moment } = this.props;
    let { text, originalText } = this.state;
    let valueId = moment.value?.id || moment.value_id;
    console.log("update value", valueId, text);
    if (!!valueId && !!text?.length) {
      valueActions.update(valueId, { title: text });
    }
  };

  showActions = async (more = false, move = false) => {
    this.actionIsVisible = true;
    let { chapter, moment } = this.props;
    let { value } = this.state;
    let subtitle = ENV.WEB ? null : value.title || value.text;
    let title = "Take Action";

    if (moment?.suggestion) {
      let options = ["Pin", "Snooze", "Dismiss"];
      let res = await alertActions.confirm({ options, title, subtitle });
      this.actionIsVisible = false;
      let i = res - 1;
      if (options[i] === "Pin") {
        this.handleEnter();
      } else if (options[i] === "Snooze") {
        // dismiss from today only (same as cmd+backspace)
        this.handleDeleteMoment(true);
      } else if (options[i] === "Dismiss") {
        // snooze for remainder of suggestion window (same as cmd+shift+backspace)
        this.handleSnoozeForWeek();
      }
      return;
    }

    // let options = value.is_note
    //   ? ["Complete", "View", "Convert from note", "More"]
    //   : ["Progress", "Complete", "View", "More"];
    let options = ["Check off", "Close out", "View", "More"];
    if (more) {
      title = "More Actions";
      // options = value.is_note
      //   ? ["Reschedule", "Move", "Remove"]
      //   : ["Reschedule", "Move", "Convert to note", "Remove"];
      options = ["Duplicate", "Cycle category", "Reschedule", "Move", "Remove"];
      if (!!chapter?.range && chapter?.range > 1) {
        options.unshift("Pin to today");
      }
    } else if (move) {
      title = "Move";
      options = [
        "Sort Up",
        "Sort Down",
        "Next Chapter",
        "Parent Chapter",
        "Child Chapter",
      ];
    }
    let res = await alertActions.confirm({
      options,
      title,
      subtitle,
    });
    this.handleActionRes(res, options);
  };

  handleActionRes = async (res, options) => {
    this.actionIsVisible = false;
    let i = res - 1;
    let { value } = this.state;
    let { rootChapter } = this.props;
    // DEFAULT
    if (options[i] == "Mark Done") this.handleMetaEnter();
    else if (options[i] == "Duplicate") {
      let res = await valueActions.duplicate(value, rootChapter?.id);
      this.props.onRefreshChapter && this.props.onRefreshChapter();
    }
    else if (options[i] == "Cycle category") this.handlCycleCategory();
    else if (["Progress", "Check off"].includes(options[i])) this.handleEnter();
    else if (["Complete", "Close out"].includes(options[i]))
      this.handleMetaEnter(false);
    else if (options[i] == "View")
      RootNavigation.push("Project", { id: value.id});
    else if (options[i]?.includes("Convert")) this.handleToggleNote();
    else if (options[i] == "Reschedule") this.toggleShowScheduler();
    else if (options[i] == "Pin to today") this.handleAltEnter();
    else if (options[i] == "Remove") this.handleDeleteMoment(false);
    // MOVE
    else if (options[i] == "Sort up")
      this.props.sortItemUp && this.props.sortItemUp();
    else if (options[i] == "Sort down")
      this.props.sortItemDown && this.props.sortItemDown();
    else if (options[i] == "Parent Chapter")
      this.props.onPinToParentChapter &&
        this.props.onPinToParentChapter(this.state.value);
    else if (options[i] == "Child Chapter") null;
    else if (options[i] == "Next Chapter") {
      // Pin to the next chapter without swapping the current view.
      await momentActions.copyToNextChapter(this.state.moment.id);
    }
    // OTHER
    else if (options[i] == "More") {
      this.showActions(true);
    } else if (options[i] == "Move") {
      this.showActions(false, true);
    }
  };

  toggleInlineActions = () => {
    let { showInlineActions } = this.state;
    if (showInlineActions) {
      this.setState({ showInlineActions: false, oneline: true });
    } else {
      this.setState({ showInlineActions: true, oneline: false });
    }
  };

  isPinnedNote = () => {
    let { pinnedMomentList, moment } = this.props;
    let value = moment?.value;
    let { expanded, focused } = this.state;
    const isPinnedNote =
      pinnedMomentList && value?.is_note && !expanded && !focused;
    return isPinnedNote;
  };

  styles = () => ({
    childIndicator: {
      position: "absolute",
      top: "50%",
      // top:
      //   (this.context.sizes.largeBulletWidth *
      //     this.context.sizes.mobileIncrease) /
      //     2 -
      //   this.context.sizes.small / 2,
      marginTop: -this.context.sizes.small / 2,
      left: -this.context.sizes.small,
      width: this.context.sizes.small,
      height: this.context.sizes.small,
      borderRadius: this.context.sizes.small,
    },
    smallChildIndicator: {
      position: "absolute",
      top: "50%",
      // top:
      //   (this.context.sizes.largeBulletWidth *
      //     this.context.sizes.mobileIncrease) /
      //     2 -
      //   this.context.sizes.tiny,
      marginTop: -this.context.sizes.tiny / 2,
      left: -this.context.sizes.tiny / 2,
      width: this.context.sizes.tiny,
      height: this.context.sizes.tiny,
      borderRadius: this.context.sizes.tiny,
    },
    childIndicatorCaret: {
      position: "absolute",
      // top:
      //   (this.context.sizes.largeBulletWidth *
      //     this.context.sizes.mobileIncrease) /
      //     2 -
      //   9,
      top: "50%",
      height: this.context.sizes.default,
      transform: [{ translateY: -this.context.sizes.default / 2 }],
      justifyContent: "center",
      // top: (this.context.sizes.largeBulletWidth * this.context.sizes.mobileIncrease) / 2 - this.context.sizes.small / 2,
      // marginTop: -this.context.sizes.small / 2,
      // left: -this.context.sizes.small,
      // width: this.context.sizes.small,
      // height: this.context.sizes.small,
      // borderRadius: this.context.sizes.small,
    },
    childIndicatorFill: {
      // ...StyleSheet.absoluteFillObject,
      position: "absolute",
      // top: this.context.sizes.tiny,
      left: this.context.sizes.tiny,
      // width: this.context.sizes.bulletWidth,
      // height: this.context.sizes.bulletWidth,
      width: this.context.sizes.large,
      height: this.context.sizes.large,
      borderRadius: 99,
      opacity: 0.15,
    },
    noteIndicatorLine: {
      position: "absolute",
      // top:
      //   (this.context.sizes.largeBulletWidth *
      //     this.context.sizes.mobileIncrease) /
      //     2 -
      //   9,
      top: "50%",
      transform: [{ translateY: -this.context.sizes.base / 2 }],
      left: -2,
      height: this.context.sizes.base,
      width: 1,
      // borderRadius: 99,
      opacity: 0.8,
    },
    noteIndicator: {
      position: "absolute",
      right: 0,
      // top: '50%',
      height: this.context.sizes.tiny,
      width: this.context.sizes.tiny,
      opacity: 0.8,
    },
    tagWrapper: {
      flexDirection: "row",
      position: "absolute",
      left: this.context.sizes.largeBulletWidth,
      // right: 0,
      padding: this.context.sizes.tiny,
      backgroundColor: this.context.colors.fill,
      backgroundColor: "transparent",
      zIndex: 1,
    },
    rightAlignedTagWrapper: {
      justifyContent: "flex-end",
      right: 0,
    },
  });
}
